/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import style from '../../../../../assets/styles/testCreationStyle.module.css';
import {
  Add_Section_Test,
  Edit_Section_Test,
  Get_All_Identifier,
  Get_Replace_question,
  changeAdd_test_screen,
  Update_Test_Details_Local,
} from '../../../../../redux/action';
import { openPreviewModal, closePreviewModal } from '../../../../atoms/Modal/modalHandlers';
import { editQuestionHandler } from '../../../../atoms/Modal/editHandlers';
import { closeModalHelper } from '../../../../atoms/Modal/duplicateHelper';
import { handleConfirmDuplicate } from '../../../../atoms/Modal/duplicateInPreviewHelper';
import staticReplace from '../../../../../assets/images/quasiReplace.svg';
import staticDelete from '../../../../../assets/images/quasiDelete.svg';
import { useDispatch, useSelector } from 'react-redux';
import BrowsingQuestion from './BrowsingQuestion';
import { GET_REVIEW_DATA } from '../../../../../action/apiPath';
import { CallWithAuth } from '../../../../../action/apiActions';
import moment from 'moment';
import QuillEditor from '../../../../atoms/QuillEditor';
import QuasiSections from '../Quasi/QuasiSections';
import { useToast } from '../../../common/Toast';
import LoftSections from '../LOFT/LoftSections';
import PreviewModal from '../../../../atoms/Modal/PreviewModal';
import LockModal from '../../../../atoms/Modal/LockModel';
import QuestionListModal from '../../../../atoms/Modal/QuestionListModal';
import { useNavigate } from 'react-router-dom';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import passageVerticalLineSvg from '../../../../../assets/images/passageVerticalLine.svg';
import colapseIcon from '../../../../../assets/images/next.svg';
import Loader from '../../../../loader';
// _________which one to show my or all _________

const Sections = ({ isEdit, onAdd, isView, getData, isPublished }) => {
  const dispatch = useDispatch();
  const [isInitialized, setIsInitialized] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const organizationId = localStorage.getItem('selectedOrgId');
  const [collapse, setCollapse] = useState({});
  const toggleCollapse = (id) => {
    setCollapse((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };
  useEffect(() => {
    dispatch(Get_All_Identifier(organizationId, '', ''));
  }, [organizationId]);
  const { identifierList, testCreationId, replacedQuestion, getBasicSettingData, testDetails, sectionBody } =
    useSelector((state) => state.GetAllData);

  const [body, setBody] = useState({
    groups: [
      {
        group_name: '',
        randomize_sections: false,
        has_unattempted_negative_marking: false,
        group_instructions: '',
        enable_reference_sheet: false,
        reference_sheet: '',
        order: 1,
        sections: [
          {
            section_name: '',
            order: 1,
            identifier: null,
            no_of_questions: 0,
            randomize_questions_within_section: false,
            correct_answer_marks: getBasicSettingData?.correct_answer_marks ?? testDetails?.correct_answer_marks,
            incorrect_answer_marks: getBasicSettingData?.incorrect_answer_marks ?? testDetails?.incorrect_answer_marks,
            questions: [],
            questionList: [],
          },
        ],
      },
    ],
  });

  //__________ Group -> add , remove , drag & drop __________
  // const [groups, setGroups] = useState([0]);
  const [groupsButton, setGroupsButton] = useState(0);
  const [bankId, setBankId] = useState(null);
  const [section, setsection] = useState([0, 1]);
  const [sectionButton, setSectionButton] = useState(0);
  const [testType, setTestType] = useState(testDetails?.test_type ?? 0);
  useEffect(() => {
    if (body?.groups[groupsButton]?.sections[sectionButton] === undefined) {
      setSectionButton(body?.groups[groupsButton]?.sections?.length - 1);
    }
  }, [groupsButton]);
  useEffect(() => {
    if (testDetails?.test_type) {
      setTestType(testDetails?.test_type);
    }
    if (getBasicSettingData) {
      setTestType(getBasicSettingData?.test_type);
    }
  }, [getBasicSettingData, testDetails]);
  const [groups, setGroups] = useState([{ id: 0, sections: [0] }]);

  // add group
  const addGroup = () => {
    setGroups([...groups, { id: groups.length, sections: [0] }]);

    setBody((prevBody) => ({
      ...prevBody,
      groups: [
        ...prevBody.groups,
        {
          group_name: '',
          randomize_sections: false,
          has_unattempted_negative_marking: false,
          group_instructions: '',
          enable_reference_sheet: false,
          reference_sheet: '',
          order: groups?.length + 1,
          sections: [
            {
              section_name: '',
              order: sectionButton + 1,
              identifier: null,
              no_of_questions: 0,
              randomize_questions_within_section: false,
              correct_answer_marks: getBasicSettingData?.correct_answer_marks ?? testDetails?.correct_answer_marks,
              incorrect_answer_marks:
                getBasicSettingData?.incorrect_answer_marks ?? testDetails?.incorrect_answer_marks,
              questions: [],
              questionList: [],
            },
          ],
        },
      ],
    }));

    SetSelectIds([]);
  };

  // close group
  const closegroups = () => {
    if (groups.length === 1) return; // Prevent removing the last group

    setGroups((prevGroups) => {
      const updatedGroups = prevGroups.filter((_, index) => index !== groupsButton);
      return updatedGroups;
    });

    setBody((prevBody) => {
      const updatedGroups = prevBody.groups.filter((_, index) => index !== groupsButton);
      return {
        ...prevBody,
        groups: updatedGroups,
      };
    });

    // Adjust the active group index
    setGroupsButton((prev) => (prev === 0 ? 0 : prev - 1));
  };
  const addSection = (groupId) => {
    const sectionOrder = groups[groupsButton]?.sections?.length + 1;
    setGroups(
      groups.map((group) => {
        if (group.id === groupId) {
          const newSectionId = group.sections.length;
          return {
            ...group,
            sections: [...group.sections, newSectionId],
          };
        }
        return group;
      })
    );

    setBody((prevBody) => {
      return {
        ...prevBody,
        groups: prevBody.groups.map((group, index) => {
          if (index === groupId) {
            const newSection = {
              order: sectionOrder,
              section_name: '',
              identifier: null,
              no_of_questions: 0,
              randomize_questions_within_section: false,
              correct_answer_marks: getBasicSettingData?.correct_answer_marks ?? testDetails?.correct_answer_marks,
              incorrect_answer_marks:
                getBasicSettingData?.incorrect_answer_marks ?? testDetails?.incorrect_answer_marks,
              questions: [],
              questionList: [],
            };
            return {
              ...group,
              sections: [...group.sections, newSection],
            };
          }
          return group;
        }),
      };
    });
  };

  const deleteSection = (groupId, sectionIndex) => {
    // Ensure there's more than one section before deleting
    setGroups((prevGroups) => {
      return prevGroups.map((group) => {
        if (group.id === groupId && group.sections.length > 1) {
          return {
            ...group,
            sections: group.sections.filter((_, idx) => idx !== sectionIndex),
          };
        }
        return group;
      });
    });
    setBody((prevBody) => {
      return {
        ...prevBody,
        groups: prevBody.groups.map((group, index) => {
          if (index === groupId && group.sections.length > 1) {
            const updatedSections = group.sections.filter((_, idx) => idx !== sectionIndex);
            // Recalculate the order
            updatedSections.forEach((section, idx) => {
              section.order = idx + 1;
            });
            return {
              ...group,
              sections: updatedSections,
            };
          }
          return group;
        }),
      };
    });
    // Update sectionButton if necessary
    setSectionButton((prevButton) => {
      // If the deleted section was the last one, move selection one section back.
      if (prevButton === sectionIndex && prevButton > 0) {
        return prevButton - 1;
      }
      // Otherwise, remain on the current selection or adjust if out of bounds.
      const maxIndex = groups[groupsButton]?.sections?.length - 2;
      return Math.min(prevButton, maxIndex);
    });
  };

  useEffect(() => {
    SetSelectIds([]);
  }, [sectionButton]);

  const ChangeGroupName = (e) => {
    const updatedBody = { ...body };
    updatedBody.groups[groupsButton].group_name = e.target.value;
    setBody(updatedBody);
  };

  const ChangeRandomize_Sections = (e) => {
    const updatedBody = { ...body };
    updatedBody.groups[groupsButton].randomize_sections = e;
    setBody(updatedBody);
  };

  const ChangeNegativePenalityMarking = (e) => {
    const updatedBody = { ...body };
    updatedBody.groups[groupsButton].has_unattempted_negative_marking = e;
    setBody(updatedBody);
  };

  const ChangeGroupInstruction = (content) => {
    const updatedBody = { ...body };
    updatedBody.groups[groupsButton].group_instructions = btoa(unescape(encodeURIComponent(content)));
    setBody(updatedBody);
  };

  const ChangeGroupReferenceSheet = (content) => {
    setBody((prevBody) => {
      const newGroups = prevBody.groups.map((group, idx) => {
        if (idx === groupsButton) {
          if (!group.enable_reference_sheet) {
            return group;
          }
          return {
            ...group,
            reference_sheet: btoa(unescape(encodeURIComponent(content))),
          };
        }
        return group;
      });
      return { ...prevBody, groups: newGroups };
    });
  };

  const ChangeGroupEnableReferenceSheet = (value) => {
    if (!value) {
      let refContent = '';
      try {
        refContent = body.groups[groupsButton].reference_sheet ? atob(body.groups[groupsButton].reference_sheet) : '';
      } catch (e) {
        refContent = '';
      }
      const hasImage = /<(img|svg)\b/i.test(refContent);
      const stripped = refContent
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/g, ' ')
        .trim();
      const hasContent = hasImage || stripped.length > 0;

      if (hasContent) {
        const confirmDisable = window.confirm(
          'Disabling the Reference Sheet will permanently delete the existing content. Do you want to proceed?'
        );
        if (!confirmDisable) {
          return;
        }
      }
    }

    setBody((prevBody) => {
      const newGroups = prevBody.groups.map((group, idx) => {
        if (idx === groupsButton) {
          return {
            ...group,
            enable_reference_sheet: value,
            reference_sheet: value ? group.reference_sheet : '',
          };
        }
        return group;
      });
      return { ...prevBody, groups: newGroups };
    });
  };

  const ChangeSectionName = (e) => {
    const updatedBody = { ...body };
    updatedBody.groups[groupsButton].sections[sectionButton].section_name = e.target.value;
    setBody(updatedBody);
  };

  const ChangeSectionIdentifier = (e) => {
    const updatedBody = { ...body };
    updatedBody.groups[groupsButton].sections[sectionButton].identifier = Number(e.target.value);
    setBody(updatedBody);
  };

  const ChangeSectionQuestionTotal = (e) => {
    const updatedBody = { ...body };
    updatedBody.groups[groupsButton].sections[sectionButton].no_of_questions = Number(e.target.value);
    setBody(updatedBody);
  };

  const ChangeSectionRandomQuestion = (e) => {
    const updatedBody = { ...body };
    updatedBody.groups[groupsButton].sections[sectionButton].randomize_questions_within_section = Boolean(e);
    setBody(updatedBody);
  };

  const [disableMarking, setDisableMarking] = useState(true);

  const ChangeSectionCorrectMarks = (e) => {
    const updatedBody = { ...body };
    updatedBody.groups[groupsButton].sections[sectionButton].correct_answer_marks = e !== '' ? Number(e) : e;
    updatedBody.groups[groupsButton].sections[sectionButton].questions.map(
      (item) => (item.correct_answer_marks = e !== '' ? Number(e) : e)
    );
    updatedBody.groups[groupsButton].sections[sectionButton].questionList.map((item) =>
      item.questions.map((el) => (el.correct_answer_marks = e !== '' ? Number(e) : e))
    );

    setBody(updatedBody);
    ChangeMarkingLogic({
      correct_answer_marks: e !== '' ? Number(e) : e,
      incorrect_answer_marks: body.groups[groupsButton].sections[sectionButton].incorrect_answer_marks,
    });
  };

  const ChangeSectionInCorrectMarks = (e) => {
    const updatedBody = { ...body };
    updatedBody.groups[groupsButton].sections[sectionButton].incorrect_answer_marks = e !== '' ? Number(e) : e;
    updatedBody.groups[groupsButton].sections[sectionButton].questions.map(
      (item) => (item.incorrect_answer_marks = e !== '' ? Number(e) : e)
    );
    updatedBody.groups[groupsButton].sections[sectionButton].questionList.map((item) =>
      item.questions.map((el) => (el.incorrect_answer_marks = e !== '' ? Number(e) : e))
    );

    setBody(updatedBody);
    ChangeMarkingLogic({
      correct_answer_marks: body.groups[groupsButton].sections[sectionButton].correct_answer_marks,
      incorrect_answer_marks: e !== '' ? Number(e) : e,
    });
  };

  useEffect(() => {
    if (getBasicSettingData !== null) {
      ChangeSectionCorrectMarks(getBasicSettingData?.correct_answer_marks ?? testDetails?.correct_answer_marks);
      ChangeSectionInCorrectMarks(getBasicSettingData?.incorrect_answer_marks ?? testDetails?.incorrect_answer_marks);
    }
  }, [getBasicSettingData]);

  const [modal, setModal] = useState(false);

  const AddQuestionFromBank = () => {
    if (body.groups[groupsButton].sections[sectionButton].no_of_questions > 0) {
      SetremoveId([]);
      setModal(true);
    } else {
      alert('please choose No. Of Questions First');
    }
  };

  const [selectIds, SetSelectIds] = useState([]);

  const AddToTestPaper = () => {
    if (selectIds.length === 0) return; // No need to proceed if selectIds is empty
    if (selectIds.length > body.groups[groupsButton].sections[sectionButton].questions.length) {
      // Update groups state with new questions for the specified group and section
      const updatedGroups = { ...body };

      const existingQuestionIds = new Set(
        updatedGroups.groups[groupsButton].sections[sectionButton].questions.map((q) => q.id)
      );
      // const newQuestions = selectIds
      //   .filter((id) => !existingQuestionIds.has(id))
      //   .map((id,index) => ({
      //     id,
      //     correct_answer_marks: getBasicSettingData?.correct_answer_marks ?? testDetails?.correct_answer_marks,
      //     incorrect_answer_marks: getBasicSettingData?.incorrect_answer_marks ?? testDetails?.incorrect_answer_marks,
      //     order: existingQuestionIds.size>0? existingQuestionIds.size+1:index+1,
      //   }));

      const newQuestions = selectIds.map((id, index) => ({
        id,
        correct_answer_marks:
          updatedGroups.groups[groupsButton].sections[sectionButton].correct_answer_marks ??
          testDetails?.correct_answer_marks,
        incorrect_answer_marks:
          updatedGroups.groups[groupsButton].sections[sectionButton].incorrect_answer_marks ??
          testDetails?.incorrect_answer_marks,
        order: index + 1,
      }));

      updatedGroups.groups[groupsButton].sections[sectionButton].questions = newQuestions;
      setBody(updatedGroups);
      QuestionListing();
    } else {
      // Clean up: Remove questions associated with the removed IDs
      const removedIds = body.groups[groupsButton].sections[sectionButton].questions
        .filter((question) => !selectIds.includes(question.id))
        .map((question) => question.id);

      if (removedIds.length >= 0) {
        const filteredQuestions = body.groups[groupsButton].sections[sectionButton].questions.filter(
          (question) => !removedIds.includes(question.id)
        );
        const updatedGroups = { ...body };
        updatedGroups.groups[groupsButton].sections[sectionButton].questions = filteredQuestions;
        setBody(updatedGroups);
        QuestionListing();
      }
    }

    setModal(false);
  };

  const [removeId, SetremoveId] = useState([]);

  const DeleteIdFromList = () => {
    if (!removeId.length) {
      toast?.remove('all');
      toast?.add('Please select any question.', 'error');
      return;
    }

    // Create a key to identify this specific group and section
    const currentKey = `group_${groupsButton}_section_${sectionButton}`;

    // Filter out the questions that should be removed
    const filteredQuestions = body.groups[groupsButton].sections[sectionButton]?.questions.filter(
      (question) => !removeId.includes(question.id)
    );

    // Create an updated copy of the body state
    const updatedGroups = { ...body };
    updatedGroups.groups[groupsButton].sections[sectionButton].questions = filteredQuestions;

    // Update the questionList to match the filtered questions
    const currentQuestionList = body.groups[groupsButton].sections[sectionButton]?.questionList || [];

    // Filter the questionList by removing items where ANY of their nested questions are in removeId
    const updatedQuestionList = currentQuestionList.filter((group) => {
      if (group.questions && Array.isArray(group.questions)) {
        const filteredGroupQuestions = group.questions.filter((question) => !removeId.includes(question.question_id));

        // If we have any questions left, update the group's questions array and keep the group
        if (filteredGroupQuestions.length > 0) {
          group.questions = filteredGroupQuestions;
          return true;
        }
        return false;
      }
      // If this is a question without nested questions (unlikely based on your structure)
      return !removeId.includes(group.question_id);
    });

    // Update the questionList in the body
    updatedGroups.groups[groupsButton].sections[sectionButton].questionList = updatedQuestionList.map(
      (item, index) => ({ ...item, order: index + 1 })
    );
    // Update the reorderedData cache to reflect the changes
    setReorderedData((prev) => ({
      ...prev,
      [currentKey]: updatedQuestionList,
    }));

    setquestionResults(updatedQuestionList);
    setBody(updatedGroups);
    SetremoveId([]);

    toast?.add('Question deleted successfully', 'success');
  };

  const RemoveIds = (items, check) => {
    if (check) {
      // Add the question ID to the removeId array
      SetremoveId((prevState) => [...prevState, items.question_id]);
    } else {
      // Remove the question ID from the removeId array
      const filteredArr = removeId.filter((value) => value !== items.question_id);
      SetremoveId(filteredArr);
    }
  };

  // question bank get
  // Get the current year
  const currentYear = new Date().getFullYear();
  // _________ PRIMARY TAG STATE INITIALIZATION _________
  const [questionId, setquestionId] = useState(0);
  const [multiselectedSubjectTag, setmultiSelectedSubjectTag] = useState([]);
  const [multiselectedFreeTag, setmultiSelectedFreeTag] = useState([]);
  const [multiselectedCategoryTag, setmultiSelectedCategoryTag] = useState([]);
  const [multiselectedAuthorTag, setmultiSelectedAuthorTag] = useState([]);
  const [sort, setSort] = useState('');
  // Initialize state for the selected year
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedYearExclude, setSelectedYearExclude] = useState(currentYear);
  // _________ YEAR USED-> STATE INITIALIZATION _________

  // ________ PAGINATION ________
  const [questionApiRender, setQuestionApiRender] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [last, setLast] = useState(5);
  const [limit, setLimit] = useState(5);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  // _________question bank id which is top dropdown _________
  const [questionBankId, setQuestionBankId] = useState(4);
  const toast = useToast();
  useEffect(() => {
    // alert(totalCount)
    if (totalCount < 5) {
      setLast(totalCount);
    } else {
      setLast(5);
    }
  }, [totalCount]);

  const handleSort = (e) => {
    if (sort === '') {
      setSort(e);
    } else if (sort === e) {
      setSort(`-${e}`);
    } else {
      setSort(e);
    }
  };

  // _________ALL question created listing data _________
  const [questionResults, setquestionResults] = useState([]);

  const [reorderedData, setReorderedData] = useState({});

  // Modify the QuestionListing function to use the reordered data when available
  const QuestionListing = async () => {
    setIsLoading(true);
    const questionsArray = body?.groups?.[groupsButton]?.sections?.[sectionButton]?.questions;
    if (!questionsArray || questionsArray?.length === 0) {
      setquestionResults([]);
      setTotalCount(0);
      setIsLoading(false);
      return;
    }

    // Create a key to identify this specific group and section
    const currentKey = `group_${groupsButton}_section_${sectionButton}`;

    // Check if we already have reordered data for this section
    if (reorderedData[currentKey]) {
      const newIds = questionsArray.map((q) => q?.id ?? q?.question_id);
      const oldIds = reorderedData[currentKey].flatMap((item) =>
        Array.isArray(item.questions)
          ? item.questions.map((q) => q?.question_id ?? q?.id)
          : [item?.question_id ?? item?.id]
      );
      setquestionResults(reorderedData[currentKey]);
      setTotalCount(questionsArray.length);

      // Important: Also update questionList from cached reordered data
      const updatedGroups = { ...body };
      updatedGroups.groups[groupsButton].sections[sectionButton].questionList = reorderedData[currentKey];
      setBody(updatedGroups);
      if (oldIds.length === newIds.length && newIds.every((v) => oldIds.includes(v))) {
        setIsLoading(false);
        return;
      }
    }

    // If we don't have cached data or need fresh data, make API call
    const questionIds = questionsArray
      .sort((a, b) => a.order - b.order)
      .map((items) => items?.id ?? items?.question_id)
      .filter((id) => id)
      .join(',');
    if (!questionIds) {
      setquestionResults([]);
      setTotalCount(0);
      setIsLoading(false);
      return;
    }
    const testId = testDetails?.id ?? testCreationId;
    const url = `${GET_REVIEW_DATA}${organizationId}/?question_ids=${questionIds}${
      isView || isEdit || (onAdd && testDetails.groups.length > 0) ? `&test_id=${testId}` : ''
    }`;

    try {
      const questionlistingData = await CallWithAuth('GET', url);
      if (questionlistingData.status && questionlistingData.res.status === 200) {
        // Preserve the original grouped structure
        // const inCorrect =body.groups[groupsButton].sections[sectionButton].incorrect_answer_marks
        // const correct =body.groups[groupsButton].sections[sectionButton].correct_answer_marks
        const groupedQuestions = questionlistingData.res.data.map((group, index) => {
          // Sort questions within each group based on their order in questionsArray
          // group.questions.map(item=>item.incorrect_answer_marks=inCorrect)
          // group.questions.map(item=>item.correct_answer_marks=correct)
          const sortedGroupQuestions = [...group.questions].sort((a, b) => {
            const aId = a?.question_id ?? a?.id;
            const bId = b?.question_id ?? b?.id;
            const indexA = questionsArray.findIndex((q) => (q?.id ?? q?.question_id) === aId);
            const indexB = questionsArray.findIndex((q) => (q?.id ?? q?.question_id) === bId);
            return indexA - indexB;
          });
          return {
            question_draft_id: group.question_draft_id,
            format: group.format,
            passage_name: group.passage_name,
            order: index + 1,
            questions: sortedGroupQuestions,
          };
        });

        // Add question_draft_id to the questions array
        const updatedQuestions = body.groups[groupsButton].sections[sectionButton].questions.map((question) => {
          // Find the matching group that contains this question
          const matchingGroup = questionlistingData.res.data.find((group) =>
            group.questions.some((q) => (q?.question_id ?? q?.id) === (question?.id ?? question?.question_id))
          );

          // Assign the question_draft_id if a match is found
          return {
            ...question,
            question_draft_id: matchingGroup ? matchingGroup.question_draft_id : null,
          };
        });

        // Use functional state updater to avoid stale closure body issues
        setBody((prevBody) => {
          const updatedGroups = { ...prevBody };
          if (updatedGroups.groups?.[groupsButton]?.sections?.[sectionButton]) {
            updatedGroups.groups[groupsButton].sections[sectionButton].questions = updatedQuestions;
            updatedGroups.groups[groupsButton].sections[sectionButton].questionList = groupedQuestions;
          }
          return updatedGroups;
        });

        setquestionResults(groupedQuestions);

        // Store this initial data in our reordered data state
        setReorderedData((prev) => ({
          ...prev,
          [currentKey]: groupedQuestions,
        }));

        setTotalCount(questionsArray.length);
      }
    } catch (error) {
      console.error('Error fetching question listing data:', error);
      // Set empty arrays if there's an error
      setquestionResults([]);
      setTotalCount(0);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    QuestionListing();
  }, [organizationId, questionBankId, questionId, offset, sort, groupsButton, sectionButton, questionApiRender]);

  // /*****Function to open edit / delete modal */
  const [showModal, setShowModal] = useState(false);

  const handleClick = (index) => {
    setShowModal((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  // __________ outside clickable close modal _______________

  const modalRef = useRef();
  const [replaceId, setReplaceId] = useState(null);

  const GetReplace = (items) => {
    setReplaceId(items.question_id);
    const testId = testDetails?.id ?? testCreationId;
    const sectionIDs = body.groups[groupsButton].sections[sectionButton]?.questions?.map((target) => target.id);
    dispatch(Get_Replace_question(organizationId, items.question_id, sectionIDs, toast, testId));
  };

  useEffect(() => {
    if (replacedQuestion !== null) {
      const id = replacedQuestion.question_id;

      setBody((prevBody) => {
        const currentSection = prevBody?.groups?.[groupsButton]?.sections?.[sectionButton];
        if (!currentSection) return prevBody;

        const newArray = currentSection.questions.map((num) =>
          num.id === replaceId
            ? {
                id: replacedQuestion.question_id,
                correct_answer_marks: getBasicSettingData?.correct_answer_marks ?? testDetails?.correct_answer_marks,
                incorrect_answer_marks:
                  getBasicSettingData?.incorrect_answer_marks ?? testDetails?.incorrect_answer_marks,
              }
            : num
        );

        const updatedGroups = { ...prevBody };
        updatedGroups.groups = prevBody.groups.map((group, gIdx) => {
          if (gIdx === groupsButton) {
            const newSections = group.sections.map((sec, sIdx) => {
              if (sIdx === sectionButton) {
                return {
                  ...sec,
                  questions: newArray,
                };
              }
              return sec;
            });
            return { ...group, sections: newSections };
          }
          return group;
        });

        return updatedGroups;
      });
      // SetSelectIds(newArray);
      setShowModal(false);
      QuestionListing();
    }
  }, [replacedQuestion]);

  const GetDelete = (items) => {
    // Create a key to identify this specific group and section
    const currentKey = `group_${groupsButton}_section_${sectionButton}`;

    // Filter out the question that should be removed from the questions array
    const filteredQuestions = body.groups[groupsButton].sections[sectionButton]?.questions.filter(
      (question) => items.question_id !== question.id
    );

    // Create an updated copy of the body state
    const updatedGroups = { ...body };
    updatedGroups.groups[groupsButton].sections[sectionButton].questions = filteredQuestions;

    // Update the questionList to match the filtered questions
    const currentQuestionList = body.groups[groupsButton].sections[sectionButton]?.questionList || [];

    // Filter the questionList by removing or updating items
    const updatedQuestionList = currentQuestionList
      .map((group) => {
        // If this group contains the question to be deleted
        if (group.questions && Array.isArray(group.questions)) {
          const filteredGroupQuestions = group.questions.filter(
            (question) => question.question_id !== items.question_id
          );
          if (filteredGroupQuestions.length > 0) {
            return { ...group, questions: filteredGroupQuestions };
          }
          // If this was the only question in the group, return null to filter it out later
          return null;
        }
        return group;
      })
      .filter(Boolean);
    // Update the questionList in the body
    updatedGroups.groups[groupsButton].sections[sectionButton].questionList = updatedQuestionList.map(
      (item, index) => ({ ...item, order: index + 1 })
    );

    // Update the reorderedData cache to reflect the changes
    setReorderedData((prev) => ({
      ...prev,
      [currentKey]: updatedQuestionList,
    }));

    // Update the questionResults state for UI display
    setquestionResults(updatedQuestionList);

    // Update the body state
    setBody(updatedGroups);

    setShowModal(false);
    toast?.add('Question deleted successfully', 'success');
  };

  const [markingLogicStatus, setMarkingLogicStatus] = useState(false);

  const [markingLogic, setMarkingLogic] = useState([
    {
      correct_answer_marks: getBasicSettingData?.correct_answer_marks ?? testDetails?.correct_answer_marks,
      incorrect_answer_marks: getBasicSettingData?.incorrect_answer_marks ?? testDetails?.incorrect_answer_marks,
    },
  ]);

  const AddNewScore = () => {
    setMarkingLogic((prevState) => [
      ...prevState,
      {
        correct_answer_marks: getBasicSettingData?.correct_answer_marks ?? testDetails?.correct_answer_marks,
        incorrect_answer_marks: getBasicSettingData?.incorrect_answer_marks ?? testDetails?.incorrect_answer_marks,
      },
    ]);
  };

  // Function to handle change event
  const handleCorrectAnswerChange = (event, i) => {
    const newValue = parseFloat(event.target.value); // Assuming input value is a number
    const updatedMarkingLogic = [...markingLogic]; // Create a copy of the state array
    updatedMarkingLogic[i] = {
      ...updatedMarkingLogic[i],
      correct_answer_marks: newValue,
    }; // Update correct_answer_marks at index 1
    setMarkingLogic(updatedMarkingLogic); // Update state with the modified array
  };

  const handleInCorrectAnswerChange = (event, i) => {
    const newValue = parseFloat(event.target.value); // Assuming input value is a number
    const updatedMarkingLogic = [...markingLogic]; // Create a copy of the state array
    updatedMarkingLogic[i] = {
      ...updatedMarkingLogic[i],
      incorrect_answer_marks: newValue,
    }; // Update correct_answer_marks at index 1
    setMarkingLogic(updatedMarkingLogic); // Update state with the modified array
  };

  const SelectedMarkingLogic = (items) => {
    // First, update the body state for the selected questions
    const updatedData = { ...body };
    updatedData.groups[groupsButton].sections[sectionButton].questions.forEach((question) => {
      if (removeId.includes(question.id)) {
        question.correct_answer_marks = items.correct_answer_marks;
        question.incorrect_answer_marks = items.incorrect_answer_marks;
      }
    });

    // Create a key to identify this specific group and section
    const currentKey = `group_${groupsButton}_section_${sectionButton}`;

    // Get the current questionList
    const currentQuestionList = body.groups[groupsButton].sections[sectionButton]?.questionList || [];

    // Update the questionList to reflect the marking logic changes
    const updatedQuestionList = currentQuestionList.map((group) => {
      // Create a deep copy of the group to avoid reference issues
      const newGroup = { ...group };

      if (group.questions && Array.isArray(group.questions)) {
        newGroup.questions = group.questions.map((question) => {
          // Only update the selected questions
          if (removeId.includes(question.question_id)) {
            return {
              ...question,
              correct_answer_marks: items.correct_answer_marks,
              incorrect_answer_marks: items.incorrect_answer_marks,
            };
          }
          return question;
        });
      }
      return newGroup;
    });

    // Update the questionList in the body
    updatedData.groups[groupsButton].sections[sectionButton].questionList = updatedQuestionList;

    // Update the questionResults state for UI display
    setquestionResults(updatedQuestionList);

    // Update the reorderedData cache to maintain consistency
    setReorderedData((prev) => ({
      ...prev,
      [currentKey]: updatedQuestionList,
    }));

    // Update the body state
    setBody(updatedData);

    // Clear selection and close the marking logic panel
    SetremoveId([]);
    setMarkingLogicStatus(!markingLogicStatus);

    // Show success toast (optional)
    toast?.add('Marking logic updated successfully', 'success');
  };

  const ChangeMarkingLogic = (items) => {
    const updatedData = { ...body };
    updatedData.groups[groupsButton].sections[sectionButton].questions.forEach((question) => {
      question.correct_answer_marks = items.correct_answer_marks;
      question.incorrect_answer_marks = items.incorrect_answer_marks;
    });
    setBody(updatedData);
    SetremoveId([]);
    // setMarkingLogicStatus(!markingLogicStatus);
  };

  const OpenMarkingLogic = () => {
    if (Array.isArray(removeId) && removeId.length > 0) {
      setMarkingLogicStatus(!markingLogicStatus);
    } else {
      alert('please choose question first');
    }
  };

  const decodeBase64 = (base64String) => {
    if (!base64String) return '';
    try {
      const binString = atob(base64String);
      const len = binString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binString.charCodeAt(i);
      }
      return new TextDecoder().decode(bytes);
    } catch (e) {
      try {
        return atob(base64String);
      } catch (err) {
        return base64String;
      }
    }
  };

  function b64DecodeUnicode(str) {
    return decodeURIComponent(
      atob(str)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
  }
  useEffect(() => {
    if (isInitialized) return;
    if (testDetails && testDetails.group_details[0] && testType !== 1) {
      const isTemplateSupported = [3, 8, 9].includes(
        Number(getBasicSettingData?.rendering_template ?? testDetails?.rendering_template)
      );
      const groupDetailsClone = structuredClone(testDetails)?.group_details || [];
      const cleanedGroups = groupDetailsClone.map((group) => {
        if (!isTemplateSupported) {
          return {
            ...group,
            enable_reference_sheet: false,
            reference_sheet: '',
          };
        }
        return group;
      });

      setBody({
        groups: cleanedGroups,
      });

      const initialGroups = cleanedGroups.map((group, index) => ({
        id: index,
        sections: group?.sections?.map((section) => section?.order),
      }));

      setGroups(initialGroups);

      setMarkingLogic((prevstate) => [
        ...prevstate,
        {
          correct_answer_marks: cleanedGroups[groupsButton]?.sections[sectionButton]?.correct_answer_marks,
          incorrect_answer_marks: cleanedGroups[groupsButton]?.sections[sectionButton]?.incorrect_answer_marks,
        },
      ]);
      setQuestionApiRender(!questionApiRender);
      setIsInitialized(true);
    }
  }, [testDetails, getBasicSettingData, isInitialized]);
  const [modalData, setModalData] = useState(null); // State to store dataToPass
  const [isDuplicatePreview, setIsDuplicatePreview] = useState(false); // State to store dataToPass
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [questionAccess, setQuestionAccess] = useState({});
  const [modalMedium, setModalMedium] = useState(false);
  const [isPreviewopen, setIsPreviewopen] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState('');
  const [actionId, setactionId] = useState(null);
  const navigate = useNavigate();
  const [questionItem, setQuestionItem] = useState({});
  const [modalModalData] = useState({
    title: 'This Question is Linked to Existing Tests',
    description:
      'The question you are about to edit has been used in one or more tests. Please be sure to click the ‘Update Exam’ button to update the changes across all tests that include this question.',
    cancelButton: 'Cancel',
    saveButton: 'Continue',
    substitle: 'Are you sure you want to proceed with editing this question?',
    className: 'quasi_modal',
  });
  // Function to handle opening the preview modal
  const onConfirmDuplicate = (
    questionBankId,
    questionId,
    questionCategory = null, // Default to null or any appropriate value
    QuestionListing = () => Promise.resolve(true), // Default to a no-op function
    MyQuestionListing = () => Promise.resolve(true) // Default to a no-op function
  ) => {
    handleConfirmDuplicate(
      organizationId,
      questionBankId,
      questionId,
      setIsModalOpen,
      setIsPreviewopen,
      setIsDuplicatePreview,
      setactionId,
      toast,
      questionCategory,
      QuestionListing,
      MyQuestionListing
    );
  };

  const closeModal = () => {
    closeModalHelper(setIsModalOpen, setModalData, setIsDuplicatePreview);
  };

  const handleOpenModal = (items) => {
    openPreviewModal(items, setSelectedQuestion, setIsPreviewopen);
  };

  const handleCloseModal = () => {
    closePreviewModal(setIsPreviewopen, setIsDuplicatePreview, setIsModalOpen);
  };

  const handleEdit = async (items) => {
    await editQuestionHandler(items, setIsPreviewopen, openModalMedium, setQuestionItem, navigate);
  };

  const openModalMedium = () => {
    setModalMedium(true);
  };
  const closeModalMedium = () => {
    setModalMedium(false);
  };
  useEffect(() => {
    const Permission = JSON.parse(sessionStorage.getItem('permissionForQuestions') || '{}');
    const newQuestionAccess = Permission?.question_bank_management?.filter((item) => item.id === bankId)[0];
    if (Permission && newQuestionAccess) {
      sessionStorage.setItem('questionAccess', JSON.stringify(newQuestionAccess));
      setQuestionAccess(newQuestionAccess);
    } else {
      setQuestionAccess({});
      const payload = { draft: false, edit: false, review: false, view: false, id: questionBankId };
      sessionStorage.setItem('questionAccess', JSON.stringify(payload));
    }
  }, [bankId]);

  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const { source, destination } = result;

    // Handle group dragging
    if (source.droppableId === 'groups-droppable') {
      setBody((prevBody) => {
        const reorderedGroups = reorder(prevBody.groups, source.index, destination.index);
        reorderedGroups.forEach((group, idx) => {
          group.order = idx + 1;
        });

        return { ...prevBody, groups: reorderedGroups };
      });

      setGroups((prevGroups) => {
        return reorder(prevGroups, source.index, destination.index).map((group, idx) => ({
          ...group,
          order: idx + 1,
          id: idx,
        }));
      });

      if (source.index === groupsButton) {
        setGroupsButton(destination.index);
      } else if (source.index < groupsButton && destination.index >= groupsButton) {
        setGroupsButton(groupsButton - 1);
      } else if (source.index > groupsButton && destination.index <= groupsButton) {
        setGroupsButton(groupsButton + 1);
      }
    }

    // Handle section dragging
    else if (source.droppableId === 'sections-droppable') {
      setBody((prevBody) => {
        const updatedGroups = prevBody.groups.map((group, idx) => {
          if (idx === groupsButton) {
            const reorderedSections = reorder(group.sections, source.index, destination.index);
            // Recalculate the order
            reorderedSections.forEach((section, idx) => {
              section.order = idx + 1;
            });

            return {
              ...group,
              sections: reorderedSections,
            };
          }
          return group;
        });

        return { ...prevBody, groups: updatedGroups };
      });

      setGroups((prevGroups) => {
        const updatedGroups = prevGroups.map((group, idx) => {
          if (idx === groupsButton) {
            const reorderedSections = reorder(group.sections, source.index, destination.index);
            return {
              ...group,
              sections: reorderedSections,
              id: idx,
            };
          }
          return group;
        });
        return updatedGroups;
      });

      if (source.index === sectionButton) {
        setSectionButton(destination.index);
      } else if (source.index < sectionButton && destination.index >= sectionButton) {
        setSectionButton(sectionButton - 1);
      } else if (source.index > sectionButton && destination.index <= sectionButton) {
        setSectionButton(sectionButton + 1);
      }

      // Clear cache for the current group's sections
      setReorderedData((prev) => {
        const newCache = { ...prev };
        // Remove all cached data for the current group
        Object.keys(newCache).forEach((key) => {
          if (key.startsWith(`group_${groupsButton}_`)) {
            delete newCache[key];
          }
        });
        return newCache;
      });
    }

    // Handle nested questions dragging (within groups with format === 1)
    else if (source.droppableId.startsWith('nested-droppable-')) {
      // Extract the question_draft_id or question_id from the droppableId
      const parentQuestionId = source.droppableId.replace('nested-droppable-', '');

      // Update questionResults state for nested questions
      if (questionResults && Array.isArray(questionResults)) {
        const newResults = JSON.parse(JSON.stringify(questionResults));

        const destinationIndex = result.destination.index;
        const currentQuestionId = result.draggableId.split('-')[result.draggableId.split('-').length - 1];
        const currentDraftId =
          result.destination.droppableId.split('-')[result.destination.droppableId.split('-').length - 1];
        const draftObj = newResults.find((item) => item.question_draft_id === Number(currentDraftId));
        if (!draftObj) return newResults; // return original if not found

        const questions = draftObj.questions;

        // Find the current index of the question
        const currentIndex = questions.findIndex((q) => q.question_id === Number(currentQuestionId));
        if (currentIndex === -1 || destinationIndex < 0 || destinationIndex >= questions.length) return;

        // Remove the question from current index
        const [movedQuestion] = questions.splice(currentIndex, 1);

        // Insert the question at the new index
        questions.splice(destinationIndex, 0, movedQuestion);

        // Update the `order` field for all questions
        questions.forEach((q, idx) => {
          q.order = idx + 1;
        });

        const updatedNestedQuestions = questions?.map((question, idx) => ({
          ...question,
          order: idx + 1,
        }));

        // Update questionResults state
        setquestionResults(newResults);

        // Update cache for nested questions
        const currentKey = `group_${groupsButton}_section_${sectionButton}_nested_${parentQuestionId}`;
        setReorderedData((prev) => ({
          ...prev,
          [currentKey]: updatedNestedQuestions,
        }));

        setBody((prevBody) => {
          const updatedGroups = structuredClone(prevBody);

          // Make sure we have the current group and section
          if (
            updatedGroups.groups &&
            updatedGroups.groups[groupsButton] &&
            updatedGroups.groups[groupsButton].sections &&
            updatedGroups.groups[groupsButton].sections[sectionButton]
          ) {
            // Get the current section we're working with
            const currentSection = updatedGroups.groups[groupsButton].sections[sectionButton];

            // Update the questionList to match our visual state
            currentSection.questionList = newResults;

            // Rebuild the questions array based on the reordered questionList
            const flattenedQuestions = [];

            // Extract all questions from the questionList to rebuild the questions array
            newResults.forEach((group, id) => {
              if (group.questions && Array.isArray(group.questions)) {
                group.questions.forEach((question) => {
                  // Find the original question from questions array to preserve all properties
                  const originalQuestion = currentSection.questions.find((q) => q.id === question.question_id);
                  if (originalQuestion) {
                    // Update order property based on the new nested order
                    flattenedQuestions.push({
                      ...originalQuestion,
                      parent_order: id + 1,
                      order: question.order || flattenedQuestions.length + 1,
                      question_draft_id: group.question_draft_id,
                    });
                  }
                });
              }
            });

            // Replace the old questions array with our newly ordered one
            currentSection.questions = flattenedQuestions;
          }

          return updatedGroups;
        });
      }
    } else if (source.droppableId === 'rows-droppable') {
      const currentKey = `group_${groupsButton}_section_${sectionButton}`;

      // Fix: First handle the visual representation (questionResults)
      if (questionResults && Array.isArray(questionResults)) {
        // Create a deep copy of questionResults to avoid mutation issues
        const newQuestionResults = JSON.parse(JSON.stringify(questionResults));

        // Extract the moved item and insert it at the new position
        const [removed] = newQuestionResults.splice(source.index, 1);
        newQuestionResults.splice(destination.index, 0, removed);

        // Update order properties for the questions in each group
        // This ensures consistent ordering visually
        let questionOrder = 1;
        newQuestionResults.forEach((group) => {
          if (group.questions && Array.isArray(group.questions)) {
            group.questions.forEach((question) => {
              if (question) {
                question.parent_order = questionOrder;
                questionOrder++;
              }
            });
          }
        });

        // Update state with the reordered questions
        setquestionResults(newQuestionResults);

        // Cache the reordered data for future reference
        setReorderedData((prev) => ({
          ...prev,
          [currentKey]: newQuestionResults,
        }));

        // Now update the body state to match the visual questionResults
        setBody((prevBody) => {
          // Need to update both the questions array and questionList array within the body
          const updatedGroups = structuredClone(prevBody);

          // Make sure we have the current group and section
          if (
            updatedGroups.groups &&
            updatedGroups.groups[groupsButton] &&
            updatedGroups.groups[groupsButton].sections &&
            updatedGroups.groups[groupsButton].sections[sectionButton]
          ) {
            // Get the current section we're working with
            const currentSection = updatedGroups.groups[groupsButton].sections[sectionButton];

            // First, update the questionList to match our visual state
            currentSection.questionList = newQuestionResults;

            // Next, rebuild the questions array based on the reordered questionList
            // We need to maintain the same structure but update the order
            const flattenedQuestions = [];

            // Extract all questions from the questionList to rebuild the questions array
            newQuestionResults.forEach((group, id) => {
              if (group.questions && Array.isArray(group.questions)) {
                group.questions.forEach((question) => {
                  // Find the original question from questions array to preserve all properties
                  const originalQuestion = currentSection.questions.find((q) => q.id === question.question_id);
                  if (originalQuestion) {
                    // Update order property if it exists
                    flattenedQuestions.push({
                      ...originalQuestion,
                      parent_order: id + 1,
                      order: question.parent_order || flattenedQuestions.length + 1,
                      question_draft_id: group.question_draft_id,
                    });
                  }
                });
              }
            });

            // Replace the old questions array with our newly ordered one
            currentSection.questions = flattenedQuestions;
          }

          return updatedGroups;
        });
      }
    }
  };

  // Improved reorder function with better error handling
  const reorder = (list, startIndex, endIndex) => {
    if (!list || !Array.isArray(list)) {
      console.error('Invalid list provided to reorder function:', list);
      return [];
    }

    // Make a fresh copy to avoid mutating the original
    const result = JSON.parse(JSON.stringify(list));

    // Ensure indices are within bounds
    if (startIndex < 0 || startIndex >= result.length || endIndex < 0 || endIndex >= result.length) {
      console.error('Reorder indices out of bounds:', { startIndex, endIndex, listLength: result.length });
      return result;
    }

    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  // Memoized serial numbers map directly derived from the active section questions
  const serialNumbersMap = useMemo(() => {
    const currentKey = `group_${groupsButton}_section_${sectionButton}`;
    const questionSetList =
      reorderedData?.[currentKey] ||
      body?.groups?.[groupsButton]?.sections?.[sectionButton]?.questionList ||
      questionResults;

    if (!Array.isArray(questionSetList)) return {};

    const newSerialMap = {};
    let currentSerialNo = 1;

    // Loop through all question sets in the current section
    questionSetList.forEach((item) => {
      if (Array.isArray(item?.questions) && item.questions.length > 0) {
        // Handle both grouped passage questions and single questions with questions array
        item.questions.forEach((q) => {
          const qId = q.question_id ?? q.id;
          if (qId !== undefined && qId !== null) {
            newSerialMap[qId] = currentSerialNo;
            newSerialMap[String(qId)] = currentSerialNo;
            newSerialMap[Number(qId)] = currentSerialNo;
            currentSerialNo++;
          }
        });
      } else {
        // Standalone question without nested questions array
        const qId = item?.question_id ?? item?.id;
        if (qId !== undefined && qId !== null) {
          newSerialMap[qId] = currentSerialNo;
          newSerialMap[String(qId)] = currentSerialNo;
          newSerialMap[Number(qId)] = currentSerialNo;
          currentSerialNo++;
        }
      }
    });

    return newSerialMap;
  }, [groupsButton, sectionButton, body, reorderedData, questionResults]);

  // Function to get the serial number for a specific question, supporting positional index or ID fallback
  const getSerialNumber = (questionId, fallbackId, cardIndex, nestedIndex = 0) => {
    if (cardIndex !== undefined && cardIndex !== null) {
      const currentKey = `group_${groupsButton}_section_${sectionButton}`;
      const questionsList =
        body?.groups?.[groupsButton]?.sections?.[sectionButton]?.questionList ||
        reorderedData?.[currentKey] ||
        questionResults;
      if (Array.isArray(questionsList) && questionsList.length > 0) {
        let count = 1;
        for (let idx = 0; idx < cardIndex && idx < questionsList.length; idx++) {
          const qItem = questionsList[idx];
          count += Array.isArray(qItem?.questions) && qItem.questions.length > 0 ? qItem.questions.length : 1;
        }
        return count + nestedIndex;
      }
      return cardIndex + 1 + nestedIndex;
    }
    const id = questionId ?? fallbackId;
    if (id === undefined || id === null) return '-';
    return serialNumbersMap[id] !== undefined ? serialNumbersMap[id] : '-';
  };
  if (testType === 0 && isLoading) {
    return <Loader />;
  }
  return (
    <>
      {testType === 0 && (
        <div className={`${style.masterTestCreation}  ${style.staticSectionCreation}`} style={{ height: '83%' }}>
          <div className={`${style.testCreationArea}`} style={{ height: 'auto', paddingBottom: '20px' }}>
            <DragDropContext onDragEnd={handleDragEnd}>
              <div className={style.containGroup} style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Droppable droppableId="groups-droppable" direction="horizontal">
                  {(provided) => (
                    <div className={style.bisectAdd} ref={provided.innerRef} {...provided.droppableProps}>
                      {groups?.map((items, i) =>
                        !isView ? (
                          <Draggable key={`group-${i + 1}`} draggableId={`group-${i}`} index={i}>
                            {(provided, snapshot) => (
                              <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                <div
                                  draggable="true"
                                  className={
                                    i === groupsButton
                                      ? `${style.multiquestionbutton} ${style.draggable}`
                                      : `${style.multiquestionbuttonBlue} ${style.draggable}`
                                  }
                                  onClick={() => {
                                    setGroupsButton(i);
                                    setSectionButton(0);
                                    SetremoveId([]);
                                  }}
                                >
                                  {i === groupsButton ? (
                                    <svg
                                      width="10"
                                      height="14"
                                      viewBox="0 0 10 14"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M3.4375 1.6875C3.4375 1.93473 3.36419 2.1764 3.22684 2.38196C3.08949 2.58752 2.89426 2.74774 2.66585 2.84235C2.43745 2.93696 2.18611 2.96171 1.94364 2.91348C1.70116 2.86525 1.47843 2.7462 1.30362 2.57138C1.1288 2.39657 1.00975 2.17384 0.961519 1.93136C0.913287 1.68889 0.938042 1.43755 1.03265 1.20915C1.12726 0.980739 1.28748 0.785516 1.49304 0.648164C1.6986 0.510812 1.94027 0.437501 2.1875 0.437501C2.51902 0.437501 2.83696 0.569197 3.07138 0.803617C3.3058 1.03804 3.4375 1.35598 3.4375 1.6875ZM7.8125 2.9375C8.05973 2.9375 8.3014 2.86419 8.50696 2.72684C8.71253 2.58949 8.87274 2.39426 8.96735 2.16585C9.06196 1.93745 9.08671 1.68611 9.03848 1.44364C8.99025 1.20116 8.8712 0.978433 8.69638 0.803617C8.52157 0.628801 8.29884 0.50975 8.05636 0.461519C7.81389 0.413287 7.56255 0.438042 7.33415 0.532651C7.10574 0.627261 6.91052 0.787477 6.77316 0.993038C6.63581 1.1986 6.5625 1.44027 6.5625 1.6875C6.5625 2.01902 6.6942 2.33696 6.92862 2.57138C7.16304 2.8058 7.48098 2.9375 7.8125 2.9375ZM2.1875 5.75C1.94027 5.75 1.6986 5.82331 1.49304 5.96066C1.28748 6.09802 1.12726 6.29324 1.03265 6.52165C0.938042 6.75005 0.913287 7.00139 0.961519 7.24386C1.00975 7.48634 1.1288 7.70907 1.30362 7.88388C1.47843 8.0587 1.70116 8.17775 1.94364 8.22598C2.18611 8.27421 2.43745 8.24946 2.66585 8.15485C2.89426 8.06024 3.08949 7.90003 3.22684 7.69446C3.36419 7.4889 3.4375 7.24723 3.4375 7C3.4375 6.66848 3.3058 6.35054 3.07138 6.11612C2.83696 5.8817 2.51902 5.75 2.1875 5.75ZM7.8125 5.75C7.56527 5.75 7.3236 5.82331 7.11804 5.96066C6.91248 6.09802 6.75226 6.29324 6.65765 6.52165C6.56304 6.75005 6.53829 7.00139 6.58652 7.24386C6.63475 7.48634 6.7538 7.70907 6.92862 7.88388C7.10343 8.0587 7.32616 8.17775 7.56864 8.22598C7.81111 8.27421 8.06245 8.24946 8.29086 8.15485C8.51926 8.06024 8.71449 7.90003 8.85184 7.69446C8.98919 7.4889 9.0625 7.24723 9.0625 7C9.0625 6.66848 8.9308 6.35054 8.69638 6.11612C8.46196 5.8817 8.14402 5.75 7.8125 5.75ZM2.1875 11.0625C1.94027 11.0625 1.6986 11.1358 1.49304 11.2732C1.28748 11.4105 1.12726 11.6057 1.03265 11.8341C0.938042 12.0626 0.913287 12.3139 0.961519 12.5564C1.00975 12.7988 1.1288 13.0216 1.30362 13.1964C1.47843 13.3712 1.70116 13.4903 1.94364 13.5385C2.18611 13.5867 2.43745 13.562 2.66585 13.4674C2.89426 13.3727 3.08949 13.2125 3.22684 13.007C3.36419 12.8014 3.4375 12.5597 3.4375 12.3125C3.4375 11.981 3.3058 11.663 3.07138 11.4286C2.83696 11.1942 2.51902 11.0625 2.1875 11.0625ZM7.8125 11.0625C7.56527 11.0625 7.3236 11.1358 7.11804 11.2732C6.91248 11.4105 6.75226 11.6057 6.65765 11.8341C6.56304 12.0626 6.53829 12.3139 6.58652 12.5564C6.63475 12.7988 6.7538 13.0216 6.92862 13.1964C7.10343 13.3712 7.32616 13.4903 7.56864 13.5385C7.81111 13.5867 8.06245 13.562 8.29086 13.4674C8.51926 13.3727 8.71449 13.2125 8.85184 13.007C8.98919 12.8014 9.0625 12.5597 9.0625 12.3125C9.0625 11.981 8.9308 11.663 8.69638 11.4286C8.46196 11.1942 8.14402 11.0625 7.8125 11.0625Z"
                                        fill="white"
                                      />
                                    </svg>
                                  ) : (
                                    <svg
                                      width="10"
                                      height="14"
                                      viewBox="0 0 10 14"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M3.4375 1.6875C3.4375 1.93473 3.36419 2.1764 3.22684 2.38196C3.08949 2.58752 2.89426 2.74774 2.66585 2.84235C2.43745 2.93696 2.18611 2.96171 1.94364 2.91348C1.70116 2.86525 1.47843 2.7462 1.30362 2.57138C1.1288 2.39657 1.00975 2.17384 0.961519 1.93136C0.913287 1.68889 0.938042 1.43755 1.03265 1.20915C1.12726 0.980739 1.28748 0.785516 1.49304 0.648164C1.6986 0.510812 1.94027 0.437501 2.1875 0.437501C2.51902 0.437501 2.83696 0.569197 3.07138 0.803617C3.3058 1.03804 3.4375 1.35598 3.4375 1.6875ZM7.8125 2.9375C8.05973 2.9375 8.3014 2.86419 8.50696 2.72684C8.71253 2.58949 8.87274 2.39426 8.96735 2.16585C9.06196 1.93745 9.08671 1.68611 9.03848 1.44364C8.99025 1.20116 8.8712 0.978433 8.69638 0.803617C8.52157 0.628801 8.29884 0.50975 8.05636 0.461519C7.81389 0.413287 7.56255 0.438042 7.33415 0.532651C7.10574 0.627261 6.91052 0.787477 6.77316 0.993038C6.63581 1.1986 6.5625 1.44027 6.5625 1.6875C6.5625 2.01902 6.6942 2.33696 6.92862 2.57138C7.16304 2.8058 7.48098 2.9375 7.8125 2.9375ZM2.1875 5.75C1.94027 5.75 1.6986 5.82331 1.49304 5.96066C1.28748 6.09802 1.12726 6.29324 1.03265 6.52165C0.938042 6.75005 0.913287 7.00139 0.961519 7.24386C1.00975 7.48634 1.1288 7.70907 1.30362 7.88388C1.47843 8.0587 1.70116 8.17775 1.94364 8.22598C2.18611 8.27421 2.43745 8.24946 2.66585 8.15485C2.89426 8.06024 3.08949 7.90003 3.22684 7.69446C3.36419 7.4889 3.4375 7.24723 3.4375 7C3.4375 6.66848 3.3058 6.35054 3.07138 6.11612C2.83696 5.8817 2.51902 5.75 2.1875 5.75ZM7.8125 5.75C7.56527 5.75 7.3236 5.82331 7.11804 5.96066C6.91248 6.09802 6.75226 6.29324 6.65765 6.52165C6.56304 6.75005 6.53829 7.00139 6.58652 7.24386C6.63475 7.48634 6.7538 7.70907 6.92862 7.88388C7.10343 8.0587 7.32616 8.17775 7.56864 8.22598C7.81111 8.27421 8.06245 8.24946 8.29086 8.15485C8.51926 8.06024 8.71449 7.90003 8.85184 7.69446C8.98919 7.4889 9.0625 7.24723 9.0625 7C9.0625 6.66848 8.9308 6.35054 8.69638 6.11612C8.46196 5.8817 8.14402 5.75 7.8125 5.75ZM2.1875 11.0625C1.94027 11.0625 1.6986 11.1358 1.49304 11.2732C1.28748 11.4105 1.12726 11.6057 1.03265 11.8341C0.938042 12.0626 0.913287 12.3139 0.961519 12.5564C1.00975 12.7988 1.1288 13.0216 1.30362 13.1964C1.47843 13.3712 1.70116 13.4903 1.94364 13.5385C2.18611 13.5867 2.43745 13.562 2.66585 13.4674C2.89426 13.3727 3.08949 13.2125 3.22684 13.007C3.36419 12.8014 3.4375 12.5597 3.4375 12.3125C3.4375 11.981 3.3058 11.663 3.07138 11.4286C2.83696 11.1942 2.51902 11.0625 2.1875 11.0625ZM7.8125 11.0625C7.56527 11.0625 7.3236 11.1358 7.11804 11.2732C6.91248 11.4105 6.75226 11.6057 6.65765 11.8341C6.56304 12.0626 6.53829 12.3139 6.58652 12.5564C6.63475 12.7988 6.7538 13.0216 6.92862 13.1964C7.10343 13.3712 7.32616 13.4903 7.56864 13.5385C7.81111 13.5867 8.06245 13.562 8.29086 13.4674C8.51926 13.3727 8.71449 13.2125 8.85184 13.007C8.98919 12.8014 9.0625 12.5597 9.0625 12.3125C9.0625 11.981 8.9308 11.663 8.69638 11.4286C8.46196 11.1942 8.14402 11.0625 7.8125 11.0625Z"
                                        fill="#272727"
                                      />
                                    </svg>
                                  )}{' '}
                                  &nbsp; Group {i + 1}
                                </div>
                              </div>
                            )}
                          </Draggable>
                        ) : (
                          <button
                            key={i}
                            className={
                              i === groupsButton
                                ? `${style.multiquestionbutton} ${style.draggable}`
                                : `${style.multiquestionbuttonBlue} ${style.draggable}`
                            }
                            onClick={() => {
                              setGroupsButton(i);
                              setSectionButton(0);
                            }}
                          >
                            {i === groupsButton ? (
                              <svg
                                width="10"
                                height="14"
                                viewBox="0 0 10 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M3.4375 1.6875C3.4375 1.93473 3.36419 2.1764 3.22684 2.38196C3.08949 2.58752 2.89426 2.74774 2.66585 2.84235C2.43745 2.93696 2.18611 2.96171 1.94364 2.91348C1.70116 2.86525 1.47843 2.7462 1.30362 2.57138C1.1288 2.39657 1.00975 2.17384 0.961519 1.93136C0.913287 1.68889 0.938042 1.43755 1.03265 1.20915C1.12726 0.980739 1.28748 0.785516 1.49304 0.648164C1.6986 0.510812 1.94027 0.437501 2.1875 0.437501C2.51902 0.437501 2.83696 0.569197 3.07138 0.803617C3.3058 1.03804 3.4375 1.35598 3.4375 1.6875ZM7.8125 2.9375C8.05973 2.9375 8.3014 2.86419 8.50696 2.72684C8.71253 2.58949 8.87274 2.39426 8.96735 2.16585C9.06196 1.93745 9.08671 1.68611 9.03848 1.44364C8.99025 1.20116 8.8712 0.978433 8.69638 0.803617C8.52157 0.628801 8.29884 0.50975 8.05636 0.461519C7.81389 0.413287 7.56255 0.438042 7.33415 0.532651C7.10574 0.627261 6.91052 0.787477 6.77316 0.993038C6.63581 1.1986 6.5625 1.44027 6.5625 1.6875C6.5625 2.01902 6.6942 2.33696 6.92862 2.57138C7.16304 2.8058 7.48098 2.9375 7.8125 2.9375ZM2.1875 5.75C1.94027 5.75 1.6986 5.82331 1.49304 5.96066C1.28748 6.09802 1.12726 6.29324 1.03265 6.52165C0.938042 6.75005 0.913287 7.00139 0.961519 7.24386C1.00975 7.48634 1.1288 7.70907 1.30362 7.88388C1.47843 8.0587 1.70116 8.17775 1.94364 8.22598C2.18611 8.27421 2.43745 8.24946 2.66585 8.15485C2.89426 8.06024 3.08949 7.90003 3.22684 7.69446C3.36419 7.4889 3.4375 7.24723 3.4375 7C3.4375 6.66848 3.3058 6.35054 3.07138 6.11612C2.83696 5.8817 2.51902 5.75 2.1875 5.75ZM7.8125 5.75C7.56527 5.75 7.3236 5.82331 7.11804 5.96066C6.91248 6.09802 6.75226 6.29324 6.65765 6.52165C6.56304 6.75005 6.53829 7.00139 6.58652 7.24386C6.63475 7.48634 6.7538 7.70907 6.92862 7.88388C7.10343 8.0587 7.32616 8.17775 7.56864 8.22598C7.81111 8.27421 8.06245 8.24946 8.29086 8.15485C8.51926 8.06024 8.71449 7.90003 8.85184 7.69446C8.98919 7.4889 9.0625 7.24723 9.0625 7C9.0625 6.66848 8.9308 6.35054 8.69638 6.11612C8.46196 5.8817 8.14402 5.75 7.8125 5.75ZM2.1875 11.0625C1.94027 11.0625 1.6986 11.1358 1.49304 11.2732C1.28748 11.4105 1.12726 11.6057 1.03265 11.8341C0.938042 12.0626 0.913287 12.3139 0.961519 12.5564C1.00975 12.7988 1.1288 13.0216 1.30362 13.1964C1.47843 13.3712 1.70116 13.4903 1.94364 13.5385C2.18611 13.5867 2.43745 13.562 2.66585 13.4674C2.89426 13.3727 3.08949 13.2125 3.22684 13.007C3.36419 12.8014 3.4375 12.5597 3.4375 12.3125C3.4375 11.981 3.3058 11.663 3.07138 11.4286C2.83696 11.1942 2.51902 11.0625 2.1875 11.0625ZM7.8125 11.0625C7.56527 11.0625 7.3236 11.1358 7.11804 11.2732C6.91248 11.4105 6.75226 11.6057 6.65765 11.8341C6.56304 12.0626 6.53829 12.3139 6.58652 12.5564C6.63475 12.7988 6.7538 13.0216 6.92862 13.1964C7.10343 13.3712 7.32616 13.4903 7.56864 13.5385C7.81111 13.5867 8.06245 13.562 8.29086 13.4674C8.51926 13.3727 8.71449 13.2125 8.85184 13.007C8.98919 12.8014 9.0625 12.5597 9.0625 12.3125C9.0625 11.981 8.9308 11.663 8.69638 11.4286C8.46196 11.1942 8.14402 11.0625 7.8125 11.0625Z"
                                  fill="white"
                                />
                              </svg>
                            ) : (
                              <svg
                                width="10"
                                height="14"
                                viewBox="0 0 10 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M3.4375 1.6875C3.4375 1.93473 3.36419 2.1764 3.22684 2.38196C3.08949 2.58752 2.89426 2.74774 2.66585 2.84235C2.43745 2.93696 2.18611 2.96171 1.94364 2.91348C1.70116 2.86525 1.47843 2.7462 1.30362 2.57138C1.1288 2.39657 1.00975 2.17384 0.961519 1.93136C0.913287 1.68889 0.938042 1.43755 1.03265 1.20915C1.12726 0.980739 1.28748 0.785516 1.49304 0.648164C1.6986 0.510812 1.94027 0.437501 2.1875 0.437501C2.51902 0.437501 2.83696 0.569197 3.07138 0.803617C3.3058 1.03804 3.4375 1.35598 3.4375 1.6875ZM7.8125 2.9375C8.05973 2.9375 8.3014 2.86419 8.50696 2.72684C8.71253 2.58949 8.87274 2.39426 8.96735 2.16585C9.06196 1.93745 9.08671 1.68611 9.03848 1.44364C8.99025 1.20116 8.8712 0.978433 8.69638 0.803617C8.52157 0.628801 8.29884 0.50975 8.05636 0.461519C7.81389 0.413287 7.56255 0.438042 7.33415 0.532651C7.10574 0.627261 6.91052 0.787477 6.77316 0.993038C6.63581 1.1986 6.5625 1.44027 6.5625 1.6875C6.5625 2.01902 6.6942 2.33696 6.92862 2.57138C7.16304 2.8058 7.48098 2.9375 7.8125 2.9375ZM2.1875 5.75C1.94027 5.75 1.6986 5.82331 1.49304 5.96066C1.28748 6.09802 1.12726 6.29324 1.03265 6.52165C0.938042 6.75005 0.913287 7.00139 0.961519 7.24386C1.00975 7.48634 1.1288 7.70907 1.30362 7.88388C1.47843 8.0587 1.70116 8.17775 1.94364 8.22598C2.18611 8.27421 2.43745 8.24946 2.66585 8.15485C2.89426 8.06024 3.08949 7.90003 3.22684 7.69446C3.36419 7.4889 3.4375 7.24723 3.4375 7C3.4375 6.66848 3.3058 6.35054 3.07138 6.11612C2.83696 5.8817 2.51902 5.75 2.1875 5.75ZM7.8125 5.75C7.56527 5.75 7.3236 5.82331 7.11804 5.96066C6.91248 6.09802 6.75226 6.29324 6.65765 6.52165C6.56304 6.75005 6.53829 7.00139 6.58652 7.24386C6.63475 7.48634 6.7538 7.70907 6.92862 7.88388C7.10343 8.0587 7.32616 8.17775 7.56864 8.22598C7.81111 8.27421 8.06245 8.24946 8.29086 8.15485C8.51926 8.06024 8.71449 7.90003 8.85184 7.69446C8.98919 7.4889 9.0625 7.24723 9.0625 7C9.0625 6.66848 8.9308 6.35054 8.69638 6.11612C8.46196 5.8817 8.14402 5.75 7.8125 5.75ZM2.1875 11.0625C1.94027 11.0625 1.6986 11.1358 1.49304 11.2732C1.28748 11.4105 1.12726 11.6057 1.03265 11.8341C0.938042 12.0626 0.913287 12.3139 0.961519 12.5564C1.00975 12.7988 1.1288 13.0216 1.30362 13.1964C1.47843 13.3712 1.70116 13.4903 1.94364 13.5385C2.18611 13.5867 2.43745 13.562 2.66585 13.4674C2.89426 13.3727 3.08949 13.2125 3.22684 13.007C3.36419 12.8014 3.4375 12.5597 3.4375 12.3125C3.4375 11.981 3.3058 11.663 3.07138 11.4286C2.83696 11.1942 2.51902 11.0625 2.1875 11.0625ZM7.8125 11.0625C7.56527 11.0625 7.3236 11.1358 7.11804 11.2732C6.91248 11.4105 6.75226 11.6057 6.65765 11.8341C6.56304 12.0626 6.53829 12.3139 6.58652 12.5564C6.63475 12.7988 6.7538 13.0216 6.92862 13.1964C7.10343 13.3712 7.32616 13.4903 7.56864 13.5385C7.81111 13.5867 8.06245 13.562 8.29086 13.4674C8.51926 13.3727 8.71449 13.2125 8.85184 13.007C8.98919 12.8014 9.0625 12.5597 9.0625 12.3125C9.0625 11.981 8.9308 11.663 8.69638 11.4286C8.46196 11.1942 8.14402 11.0625 7.8125 11.0625Z"
                                  fill="#272727"
                                />
                              </svg>
                            )}{' '}
                            &nbsp; Group {i + 1}
                          </button>
                        )
                      )}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
                <div
                  className={`${style.icon_text} ${style.group_icon} ${isView ? style.isViewMainContainer : ''}`}
                  style={{ marginRight: '24px' }}
                >
                  <div
                    style={{
                      border: '1px solid #3ebb5d',
                      height: '20px',
                      width: '20px',
                      borderRadius: '6px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      ChangeRandomize_Sections(!body?.groups[groupsButton]?.randomize_sections);
                    }}
                  >
                    {body?.groups[groupsButton]?.randomize_sections ? (
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                          fill="url(#paint0_linear_1449_53208)"
                        />
                        <path
                          d="M7.75 12.0019L10.58 14.8319L16.25 9.17188"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear_1449_53208"
                            x1="22"
                            y1="2"
                            x2="7.89816"
                            y2="18.4928"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#9BF763" />
                            <stop offset="1" stopColor="#25AB5B" />
                          </linearGradient>
                        </defs>
                      </svg>
                    ) : (
                      ''
                    )}
                  </div>

                  <p className={style.info}>Randomize Sections Within Group</p>
                </div>
              </div>

              {!isView && (
                <div style={{ display: 'flex', justifyContent: 'space-between' }} className={style.threshold}>
                  <div
                    className={style.setter}
                    // onClick={() => setGroups((current) => [...current, groups.length])}
                    onClick={() => addGroup()}
                  >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                        stroke="#00ABFB"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M7.5 12H16.5"
                        stroke="#00ABFB"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M12 16.5V7.5"
                        stroke="#00ABFB"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <h5>Add Group</h5>
                  </div>
                  {/* group add button  */}
                  {groups.length > 1 && (onAdd || (isEdit && testDetails?.remove_groups)) && (
                    <button className={style.removeGroupButton} onClick={() => closegroups()}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M18.8504 9.14062L18.2004 19.2106C18.0904 20.7806 18.0004 22.0006 15.2104 22.0006H8.79039C6.00039 22.0006 5.91039 20.7806 5.80039 19.2106L5.15039 9.14062"
                          stroke="#272727"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M21 5.98047C17.67 5.65047 14.32 5.48047 10.98 5.48047C9 5.48047 7.02 5.58047 5.04 5.78047L3 5.98047"
                          stroke="#272727"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
                          stroke="#272727"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      Remove Group
                    </button>
                  )}
                </div>
              )}
              {body.groups
                .filter((item, key) => key === groupsButton)
                .map((items, i) => (
                  <div key={i} className={style.section_form} style={{ padding: '20px' }}>
                    <h5 className={style.testMarklabel} style={{ margin: '0px 0px 12px' }}>
                      Group {groupsButton + 1} Details
                    </h5>
                    {/* group details -body  */}
                    <div className={`${style.groupName} ${isView ? style.isViewMainContainer : ''}`}>
                      <span style={{ fontSize: '14px', fontWeight: '500', margin: '10px 0px' }}>
                        Group Name
                        {''} <span className={style.red_mendantory}> *</span>
                      </span>

                      <input
                        type="textArea"
                        placeholder="Group Name"
                        className={style.groupDrop}
                        onChange={(e) => ChangeGroupName(e)}
                        value={items.group_name}
                      />

                      <span style={{ fontSize: '14px', fontWeight: '500' }}>Group Instructions</span>
                      <div style={{ height: 'auto', flexGrow: '1' }}>
                        <QuillEditor
                          key={i}
                          defaultValue={decodeBase64(items.group_instructions)}
                          onChange={(content) => ChangeGroupInstruction(content)}
                          disabled={isView}
                        />
                      </div>

                      {[3, 8, 9].includes(
                        Number(getBasicSettingData?.rendering_template ?? testDetails?.rendering_template)
                      ) && (
                        <div className={style.toggleGroups} style={{ marginTop: '15px' }}>
                          <span className={style.btnLabel}>Enable Reference Sheet</span>
                          <div className={`${style.toggleButtons}`}>
                            <button
                              type="button"
                              className={!items.enable_reference_sheet ? `${style.active}` : `${style.notActive}`}
                              onClick={() => ChangeGroupEnableReferenceSheet(false)}
                              disabled={isView}
                            >
                              No
                            </button>
                            <button
                              type="button"
                              className={items.enable_reference_sheet ? `${style.active}` : `${style.notActive}`}
                              onClick={() => ChangeGroupEnableReferenceSheet(true)}
                              disabled={isView}
                            >
                              Yes
                            </button>
                          </div>
                        </div>
                      )}

                      {[3, 8, 9].includes(
                        Number(getBasicSettingData?.rendering_template ?? testDetails?.rendering_template)
                      ) &&
                        items.enable_reference_sheet && (
                          <>
                            <span style={{ fontSize: '14px', fontWeight: '500', marginTop: '15px' }}>
                              Reference Sheet
                            </span>
                            <div style={{ height: 'auto', flexGrow: '1' }}>
                              <QuillEditor
                                key={`ref-${i}`}
                                defaultValue={decodeBase64(items.reference_sheet || '')}
                                onChange={(content) => ChangeGroupReferenceSheet(content)}
                                disabled={isView}
                              />
                            </div>
                          </>
                        )}

                      {(getBasicSettingData?.rendering_template === 5 || testDetails?.rendering_template === 5) && (
                        <div className={`${style.icon_text} ${style.group_icon}`}>
                          <div
                            style={{
                              border: '1px solid #3ebb5d',
                              height: '20px',
                              width: '20px',
                              borderRadius: '6px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                            onClick={() =>
                              ChangeNegativePenalityMarking(!body.groups[groupsButton].has_unattempted_negative_marking)
                            }
                          >
                            {body.groups[groupsButton].has_unattempted_negative_marking ? (
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                                  fill="url(#paint0_linear_1449_53208)"
                                />
                                <path
                                  d="M7.75 12.0019L10.58 14.8319L16.25 9.17188"
                                  stroke="white"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <defs>
                                  <linearGradient
                                    id="paint0_linear_1449_53208"
                                    x1="22"
                                    y1="2"
                                    x2="7.89816"
                                    y2="18.4928"
                                    gradientUnits="userSpaceOnUse"
                                  >
                                    <stop stopColor="#9BF763" />
                                    <stop offset="1" stopColor="#25AB5B" />
                                  </linearGradient>
                                </defs>
                              </svg>
                            ) : (
                              ''
                            )}
                          </div>

                          <p className={style.info}>Has Unattempted Negative Marking</p>
                        </div>
                      )}
                    </div>

                    <h5 className={style.testMarklabel}>Sections</h5>
                    {/* section buttons  */}
                    <Droppable droppableId="sections-droppable" direction="horizontal">
                      {(provided) => (
                        <div
                          className={style.containGroup}
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                          style={{ display: 'flex', flexWrap: 'wrap', width: 'auto' }}
                        >
                          {items?.sections?.map((item, i) =>
                            !isView ? (
                              <Draggable key={i} draggableId={`section-${i}`} index={i}>
                                {(provided, snapshot) => (
                                  <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                  >
                                    <div
                                      key={i}
                                      className={
                                        i === sectionButton
                                          ? `${style.multiquestionbutton} ${style.draggable}`
                                          : `${style.multiquestionbuttonBlue} ${style.draggable}`
                                      }
                                      onClick={() => {
                                        setSectionButton(i);
                                        SetremoveId([]);
                                      }}
                                    >
                                      {i === sectionButton ? (
                                        <svg
                                          width="10"
                                          height="14"
                                          viewBox="0 0 10 14"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M3.4375 1.6875C3.4375 1.93473 3.36419 2.1764 3.22684 2.38196C3.08949 2.58752 2.89426 2.74774 2.66585 2.84235C2.43745 2.93696 2.18611 2.96171 1.94364 2.91348C1.70116 2.86525 1.47843 2.7462 1.30362 2.57138C1.1288 2.39657 1.00975 2.17384 0.961519 1.93136C0.913287 1.68889 0.938042 1.43755 1.03265 1.20915C1.12726 0.980739 1.28748 0.785516 1.49304 0.648164C1.6986 0.510812 1.94027 0.437501 2.1875 0.437501C2.51902 0.437501 2.83696 0.569197 3.07138 0.803617C3.3058 1.03804 3.4375 1.35598 3.4375 1.6875ZM7.8125 2.9375C8.05973 2.9375 8.3014 2.86419 8.50696 2.72684C8.71253 2.58949 8.87274 2.39426 8.96735 2.16585C9.06196 1.93745 9.08671 1.68611 9.03848 1.44364C8.99025 1.20116 8.8712 0.978433 8.69638 0.803617C8.52157 0.628801 8.29884 0.50975 8.05636 0.461519C7.81389 0.413287 7.56255 0.438042 7.33415 0.532651C7.10574 0.627261 6.91052 0.787477 6.77316 0.993038C6.63581 1.1986 6.5625 1.44027 6.5625 1.6875C6.5625 2.01902 6.6942 2.33696 6.92862 2.57138C7.16304 2.8058 7.48098 2.9375 7.8125 2.9375ZM2.1875 5.75C1.94027 5.75 1.6986 5.82331 1.49304 5.96066C1.28748 6.09802 1.12726 6.29324 1.03265 6.52165C0.938042 6.75005 0.913287 7.00139 0.961519 7.24386C1.00975 7.48634 1.1288 7.70907 1.30362 7.88388C1.47843 8.0587 1.70116 8.17775 1.94364 8.22598C2.18611 8.27421 2.43745 8.24946 2.66585 8.15485C2.89426 8.06024 3.08949 7.90003 3.22684 7.69446C3.36419 7.4889 3.4375 7.24723 3.4375 7C3.4375 6.66848 3.3058 6.35054 3.07138 6.11612C2.83696 5.8817 2.51902 5.75 2.1875 5.75ZM7.8125 5.75C7.56527 5.75 7.3236 5.82331 7.11804 5.96066C6.91248 6.09802 6.75226 6.29324 6.65765 6.52165C6.56304 6.75005 6.53829 7.00139 6.58652 7.24386C6.63475 7.48634 6.7538 7.70907 6.92862 7.88388C7.10343 8.0587 7.32616 8.17775 7.56864 8.22598C7.81111 8.27421 8.06245 8.24946 8.29086 8.15485C8.51926 8.06024 8.71449 7.90003 8.85184 7.69446C8.98919 7.4889 9.0625 7.24723 9.0625 7C9.0625 6.66848 8.9308 6.35054 8.69638 6.11612C8.46196 5.8817 8.14402 5.75 7.8125 5.75ZM2.1875 11.0625C1.94027 11.0625 1.6986 11.1358 1.49304 11.2732C1.28748 11.4105 1.12726 11.6057 1.03265 11.8341C0.938042 12.0626 0.913287 12.3139 0.961519 12.5564C1.00975 12.7988 1.1288 13.0216 1.30362 13.1964C1.47843 13.3712 1.70116 13.4903 1.94364 13.5385C2.18611 13.5867 2.43745 13.562 2.66585 13.4674C2.89426 13.3727 3.08949 13.2125 3.22684 13.007C3.36419 12.8014 3.4375 12.5597 3.4375 12.3125C3.4375 11.981 3.3058 11.663 3.07138 11.4286C2.83696 11.1942 2.51902 11.0625 2.1875 11.0625ZM7.8125 11.0625C7.56527 11.0625 7.3236 11.1358 7.11804 11.2732C6.91248 11.4105 6.75226 11.6057 6.65765 11.8341C6.56304 12.0626 6.53829 12.3139 6.58652 12.5564C6.63475 12.7988 6.7538 13.0216 6.92862 13.1964C7.10343 13.3712 7.32616 13.4903 7.56864 13.5385C7.81111 13.5867 8.06245 13.562 8.29086 13.4674C8.51926 13.3727 8.71449 13.2125 8.85184 13.007C8.98919 12.8014 9.0625 12.5597 9.0625 12.3125C9.0625 11.981 8.9308 11.663 8.69638 11.4286C8.46196 11.1942 8.14402 11.0625 7.8125 11.0625Z"
                                            fill="white"
                                          />
                                        </svg>
                                      ) : (
                                        <svg
                                          width="10"
                                          height="14"
                                          viewBox="0 0 10 14"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M3.4375 1.6875C3.4375 1.93473 3.36419 2.1764 3.22684 2.38196C3.08949 2.58752 2.89426 2.74774 2.66585 2.84235C2.43745 2.93696 2.18611 2.96171 1.94364 2.91348C1.70116 2.86525 1.47843 2.7462 1.30362 2.57138C1.1288 2.39657 1.00975 2.17384 0.961519 1.93136C0.913287 1.68889 0.938042 1.43755 1.03265 1.20915C1.12726 0.980739 1.28748 0.785516 1.49304 0.648164C1.6986 0.510812 1.94027 0.437501 2.1875 0.437501C2.51902 0.437501 2.83696 0.569197 3.07138 0.803617C3.3058 1.03804 3.4375 1.35598 3.4375 1.6875ZM7.8125 2.9375C8.05973 2.9375 8.3014 2.86419 8.50696 2.72684C8.71253 2.58949 8.87274 2.39426 8.96735 2.16585C9.06196 1.93745 9.08671 1.68611 9.03848 1.44364C8.99025 1.20116 8.8712 0.978433 8.69638 0.803617C8.52157 0.628801 8.29884 0.50975 8.05636 0.461519C7.81389 0.413287 7.56255 0.438042 7.33415 0.532651C7.10574 0.627261 6.91052 0.787477 6.77316 0.993038C6.63581 1.1986 6.5625 1.44027 6.5625 1.6875C6.5625 2.01902 6.6942 2.33696 6.92862 2.57138C7.16304 2.8058 7.48098 2.9375 7.8125 2.9375ZM2.1875 5.75C1.94027 5.75 1.6986 5.82331 1.49304 5.96066C1.28748 6.09802 1.12726 6.29324 1.03265 6.52165C0.938042 6.75005 0.913287 7.00139 0.961519 7.24386C1.00975 7.48634 1.1288 7.70907 1.30362 7.88388C1.47843 8.0587 1.70116 8.17775 1.94364 8.22598C2.18611 8.27421 2.43745 8.24946 2.66585 8.15485C2.89426 8.06024 3.08949 7.90003 3.22684 7.69446C3.36419 7.4889 3.4375 7.24723 3.4375 7C3.4375 6.66848 3.3058 6.35054 3.07138 6.11612C2.83696 5.8817 2.51902 5.75 2.1875 5.75ZM7.8125 5.75C7.56527 5.75 7.3236 5.82331 7.11804 5.96066C6.91248 6.09802 6.75226 6.29324 6.65765 6.52165C6.56304 6.75005 6.53829 7.00139 6.58652 7.24386C6.63475 7.48634 6.7538 7.70907 6.92862 7.88388C7.10343 8.0587 7.32616 8.17775 7.56864 8.22598C7.81111 8.27421 8.06245 8.24946 8.29086 8.15485C8.51926 8.06024 8.71449 7.90003 8.85184 7.69446C8.98919 7.4889 9.0625 7.24723 9.0625 7C9.0625 6.66848 8.9308 6.35054 8.69638 6.11612C8.46196 5.8817 8.14402 5.75 7.8125 5.75ZM2.1875 11.0625C1.94027 11.0625 1.6986 11.1358 1.49304 11.2732C1.28748 11.4105 1.12726 11.6057 1.03265 11.8341C0.938042 12.0626 0.913287 12.3139 0.961519 12.5564C1.00975 12.7988 1.1288 13.0216 1.30362 13.1964C1.47843 13.3712 1.70116 13.4903 1.94364 13.5385C2.18611 13.5867 2.43745 13.562 2.66585 13.4674C2.89426 13.3727 3.08949 13.2125 3.22684 13.007C3.36419 12.8014 3.4375 12.5597 3.4375 12.3125C3.4375 11.981 3.3058 11.663 3.07138 11.4286C2.83696 11.1942 2.51902 11.0625 2.1875 11.0625ZM7.8125 11.0625C7.56527 11.0625 7.3236 11.1358 7.11804 11.2732C6.91248 11.4105 6.75226 11.6057 6.65765 11.8341C6.56304 12.0626 6.53829 12.3139 6.58652 12.5564C6.63475 12.7988 6.7538 13.0216 6.92862 13.1964C7.10343 13.3712 7.32616 13.4903 7.56864 13.5385C7.81111 13.5867 8.06245 13.562 8.29086 13.4674C8.51926 13.3727 8.71449 13.2125 8.85184 13.007C8.98919 12.8014 9.0625 12.5597 9.0625 12.3125C9.0625 11.981 8.9308 11.663 8.69638 11.4286C8.46196 11.1942 8.14402 11.0625 7.8125 11.0625Z"
                                            fill="#272727"
                                          />
                                        </svg>
                                      )}{' '}
                                      &nbsp; Section {i + 1}
                                    </div>
                                  </div>
                                )}
                              </Draggable>
                            ) : (
                              <button
                                key={i}
                                className={
                                  i === sectionButton
                                    ? `${style.multiquestionbutton} ${style.draggable}`
                                    : `${style.multiquestionbuttonBlue} ${style.draggable}`
                                }
                                onClick={() => setSectionButton(i)}
                              >
                                &nbsp; Section {i + 1}
                              </button>
                            )
                          )}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                    {/* section add button  */}
                    {!isView && (
                      <div style={{ display: 'flex', justifyContent: 'space-between' }} className={style.threshold}>
                        <div
                          className={style.setter}
                          // onClick={() =>
                          //   setsection((current) => [...current, section.length])
                          // }
                          onClick={() => addSection(groups[groupsButton].id)}
                        >
                          {' '}
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                              stroke="#00ABFB"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M7.5 12H16.5"
                              stroke="#00ABFB"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M12 16.5V7.5"
                              stroke="#00ABFB"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          <h5>Add Section</h5>{' '}
                        </div>

                        {items.sections.length > 1 && (onAdd || (isEdit && testDetails?.remove_sections)) && (
                          <button
                            className={` ${style.removeGroupButton} ${style.section_remove}`}
                            onClick={() => deleteSection(groups[groupsButton].id, sectionButton)}
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M18.8504 9.14062L18.2004 19.2106C18.0904 20.7806 18.0004 22.0006 15.2104 22.0006H8.79039C6.00039 22.0006 5.91039 20.7806 5.80039 19.2106L5.15039 9.14062"
                                stroke="#272727"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M21 5.98047C17.67 5.65047 14.32 5.48047 10.98 5.48047C9 5.48047 7.02 5.58047 5.04 5.78047L3 5.98047"
                                stroke="#272727"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
                                stroke="#272727"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                            Remove Section
                          </button>
                        )}
                      </div>
                    )}

                    {items?.sections
                      .filter((item, key) => key === sectionButton)
                      .map((sectionItem, sectionKey) => (
                        <div
                          className={`${style.pageTwoSection}  ${isView ? style.isViewMainContainer : ''}`}
                          key={sectionKey + 1}
                          style={{ padding: '15px 15px 30px', height: 'auto' }}
                        >
                          <div className={style.bound}>
                            <div className={style.templateDrop} key={sectionKey + 1}>
                              <div className={style.templateDrop_item}>
                                <div className={style.templateGroup} style={{ marginLeft: '0px' }}>
                                  <span>Section Name </span>
                                  <b className={style.red_mendantory}>*</b>
                                  <input
                                    name="question"
                                    id="question"
                                    autoComplete="off"
                                    className={` ${style.score_drop_filter} ${style.verbalBox}`}
                                    placeholder=""
                                    onChange={(e) => ChangeSectionName(e)}
                                    value={sectionItem.section_name}
                                  />
                                </div>
                              </div>
                            </div>

                            {/* Test type */}
                            <div className={style.templateDrop} key={sectionKey}>
                              <div className={style.templateDrop_item}>
                                <div className={style.templateGroup}>
                                  <span>Section Identifier </span>
                                  <b className={style.red_mendantory}>*</b>
                                  <select
                                    name="question"
                                    id="question"
                                    value={
                                      sectionItem?.identifier === null
                                        ? 'Select Section Identifier'
                                        : sectionItem?.identifier
                                    }
                                    onChange={(e) => ChangeSectionIdentifier(e)}
                                    className={` ${style.template_drop_filter} ${style.varc}`}
                                  >
                                    <option value={null}>Select Section Identifier</option>
                                    {Array.isArray(identifierList) &&
                                      identifierList?.map((items, i) => (
                                        <option key={i} value={items?.id}>
                                          {items?.name}
                                        </option>
                                      ))}
                                  </select>
                                </div>
                              </div>
                            </div>

                            <div className={style.templateDrop} key={sectionKey}>
                              <div className={style.templateDrop_item}>
                                <div className={style.templateGroup}>
                                  <span>No. of Questions</span>
                                  <b className={style.red_mendantory}>*</b>
                                  <input
                                    name="question"
                                    id="question"
                                    className={style.score_drop_filter}
                                    placeholder=""
                                    autoComplete="off"
                                    onChange={(e) => ChangeSectionQuestionTotal(e)}
                                    value={sectionItem.no_of_questions}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <p style={{ fontWeight: '500' }} className={style.marketLogic}>
                            Randomize Questions Within Section <span className={style.red_mendantory}>*</span>
                          </p>
                          <div className={style.levels}>
                            <input
                              type="radio"
                              checked={String(sectionItem.randomize_questions_within_section).toLowerCase() === 'true'}
                              onClick={() => ChangeSectionRandomQuestion(true)}
                            />
                            <label htmlFor="test level">Yes</label>
                            <input
                              type="radio"
                              style={{ marginLeft: '20px' }}
                              checked={String(sectionItem.randomize_questions_within_section).toLowerCase() === 'false'}
                              onClick={() => ChangeSectionRandomQuestion(false)}
                            />
                            <label htmlFor="section level">No</label>
                          </div>
                          <hr className={style.sectionsHR} />
                          <h3 className={style.testMarklabel}>Group Marking Details</h3>
                          <p className={style.info}>
                            Editing marking logic will only apply to selected section. All questions will follow same
                            marking logic unless new marking logics are created
                          </p>
                          <div className={style.bound}>
                            <div className={style.templateDrop} key={sectionKey}>
                              <div className={style.templateDrop_item}>
                                <div className={style.templateGroup}>
                                  <span>Correct Answer Marks </span>
                                  <b className={style.red_mendantory}>*</b>
                                  <input
                                    type="number"
                                    name="question"
                                    disabled={disableMarking}
                                    id="question"
                                    className={` ${style.score_drop_filter} ${style.fullBgmarks}`}
                                    placeholder=""
                                    onChange={(e) => ChangeSectionCorrectMarks(e.target.value)}
                                    value={
                                      sectionItem.correct_answer_marks === null
                                        ? testDetails?.correct_answer_marks
                                        : sectionItem.correct_answer_marks
                                    }
                                  />
                                </div>
                              </div>
                            </div>

                            <div className={style.templateDrop}>
                              <div className={style.templateDrop_item}>
                                <div className={style.templateGroup}>
                                  <span>Incorrect Answer Marks </span>
                                  <b className={style.red_mendantory}>*</b>
                                  <input
                                    type="number"
                                    disabled={disableMarking}
                                    name="question"
                                    id="question"
                                    className={` ${style.score_drop_filter} ${style.fullBgmarks}`}
                                    placeholder=""
                                    onChange={(e) => ChangeSectionInCorrectMarks(e.target.value)}
                                    value={
                                      sectionItem.incorrect_answer_marks === null
                                        ? testDetails?.incorrect_answer_marks
                                        : sectionItem.incorrect_answer_marks
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                            {!isView && (
                              <div>
                                {disableMarking ? (
                                  <div
                                    onClick={() => setDisableMarking(false)}
                                    style={{ cursor: 'pointer' }}
                                    className={style.threshold}
                                  >
                                    <svg
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M3 22H21"
                                        stroke="#00ABFB"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M13.2594 3.59924L5.04936 12.2892C4.73936 12.6192 4.43936 13.2692 4.37936 13.7192L4.00936 16.9592C3.87936 18.1292 4.71936 18.9292 5.87936 18.7292L9.09936 18.1792C9.54936 18.0992 10.1794 17.7692 10.4894 17.4292L18.6994 8.73924C20.1194 7.23924 20.7594 5.52924 18.5494 3.43924C16.3494 1.36924 14.6794 2.09924 13.2594 3.59924Z"
                                        stroke="#00ABFB"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M11.8906 5.04883C12.3206 7.80883 14.5606 9.91883 17.3406 10.1988"
                                        stroke="#00ABFB"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>

                                    <h5>Edit</h5>
                                  </div>
                                ) : (
                                  <div
                                    onClick={() => setDisableMarking(true)}
                                    style={{ cursor: 'pointer' }}
                                    className={style.threshold}
                                  >
                                    <h5>Done</h5>
                                    <svg
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                                        fill="url(#paint0_linear_1449_53208)"
                                      />
                                      <path
                                        d="M7.75 12.0019L10.58 14.8319L16.25 9.17188"
                                        stroke="white"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <defs>
                                        <linearGradient
                                          id="paint0_linear_1449_53208"
                                          x1="22"
                                          y1="2"
                                          x2="7.89816"
                                          y2="18.4928"
                                          gradientUnits="userSpaceOnUse"
                                        >
                                          <stop stopColor="#00ABFB" />
                                          <stop offset="1" stopColor="#00ABFB" />
                                        </linearGradient>
                                      </defs>
                                    </svg>
                                  </div>
                                )}
                              </div>
                            )}
                            {/* Test type */}
                          </div>
                          <hr className={style.sectionsHR} />
                          {/* question list  */}
                          {sectionItem?.questions?.length === 0 ? (
                            <div className={style.ruleContainer}>
                              <h2 className={style.title}>No Questions Added!</h2>
                              <p className={style.description}>
                                Please click “Add questions from question bank” button to proceed.
                              </p>
                              <button
                                className={`${style.addNewQuestionBt} ${style.addNewQuestionBank_new} `}
                                onClick={() => AddQuestionFromBank()}
                                style={{ visibility: isView ? 'hidden' : 'visible' }}
                              >
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M2.16797 10H18.168"
                                    stroke="#00ABFB"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M10.168 18V2"
                                    stroke="#00ABFB"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                                <span> Add questions from question bank</span>
                              </button>
                            </div>
                          ) : (
                            <div className={style.questionBank}>
                              <div className={`${isView ? style.isViewMainContainer : ''}`}>
                                <div className={style.headerBank}>
                                  <h4 style={{ fontWeight: '500' }}>Question List</h4>

                                  {!isView && (
                                    <button className={style.addNewQuestionBt} onClick={() => AddQuestionFromBank()}>
                                      <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M2.16797 10H18.168"
                                          stroke="#00ABFB"
                                          strokeWidth="3"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                        <path
                                          d="M10.168 18V2"
                                          stroke="#00ABFB"
                                          strokeWidth="3"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                      <span> Add questions from question bank</span>
                                    </button>
                                  )}
                                </div>
                                <div className={style.handleAttempt}>
                                  <span> {sectionItem.questions?.length}</span>
                                  <span style={{ color: 'lightgray' }}>/{sectionItem.no_of_questions}</span>
                                  <span> selected</span>
                                </div>
                              </div>
                              <Droppable droppableId="rows-droppable">
                                {(provided) => (
                                  <div
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                    className={`${style.staticCardsGrid} ${isView ? style.isViewMainContainer : ''}`}
                                  >
                                    {sectionItem?.questionList?.map((items, i) => (
                                      <Draggable
                                        key={items.question_draft_id || items.question_id}
                                        draggableId={`row-${items?.question_draft_id || items?.question_id}`}
                                        index={i}
                                      >
                                        {(provided, snapshot) => (
                                          <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            className={`${style.questionCard} ${style.questionCard_new} ${
                                              snapshot.isDragging ? style.dragging : ''
                                            }`}
                                            style={{
                                              ...provided.draggableProps.style,
                                              background: snapshot.isDragging ? '#f0f0f0' : 'white',
                                              marginBottom: '16px',
                                            }}
                                          >
                                            {/* Header for grouped questions */}
                                            {items?.format === 1 && (
                                              <div className={style.GroupHeaderWrap}>
                                                <div className={style.passageHeader}>
                                                  <span>{items.passage_name}</span>
                                                </div>
                                                <div
                                                  className={`${style.colapseIconwrap} ${
                                                    collapse[items.question_draft_id || items.question_id]
                                                      ? style.colapseIconRotated
                                                      : ''
                                                  }`}
                                                  onClick={() =>
                                                    toggleCollapse(items.question_draft_id || items.question_id)
                                                  }
                                                >
                                                  <img
                                                    src={colapseIcon}
                                                    className={style.colapseIcon}
                                                    alt="colapseIcon"
                                                  />
                                                </div>
                                              </div>
                                            )}

                                            {items.format === 1 && items.passage_name !== null && (
                                              <img
                                                src={passageVerticalLineSvg}
                                                className={`${style.PassageVertical_line} ${style.questionContent} ${
                                                  collapse[items.question_draft_id || items.question_id]
                                                    ? style.questionContentCollapsed
                                                    : style.questionContentExpanded
                                                }`}
                                                alt="Vertical Line"
                                              />
                                            )}

                                            {/* Map through questions in this group */}
                                            {items?.format === 1 && items?.questions?.length > 0 ? (
                                              <Droppable
                                                key={items.question_draft_id || items.question_id}
                                                droppableId={`nested-droppable-${
                                                  items.question_draft_id || items.question_id
                                                }`}
                                                type={`nested-questions-${items.question_draft_id || items.question_id}`}
                                                isDropDisabled={false}
                                              >
                                                {(nestedProvided) => (
                                                  <div
                                                    ref={nestedProvided.innerRef}
                                                    {...nestedProvided.droppableProps}
                                                    className={style.nestedQuestionsContainer}
                                                  >
                                                    {items.questions.map((items, nestedIndex) => (
                                                      <div
                                                        key={items.question_draft_id || items.question_id}
                                                        className={`${
                                                          collapse[items.question_draft_id || items.question_id]
                                                            ? style.questionContentCollapsed
                                                            : style.questionContentExpanded
                                                        }`}
                                                      >
                                                        <Draggable
                                                          key={items.question_id}
                                                          draggableId={`nested-${items.question_id}`}
                                                          index={nestedIndex}
                                                          isDragDisabled={false}
                                                        >
                                                          {(nestedDragProvided, nestedSnapshot) => (
                                                            <div
                                                              ref={nestedDragProvided.innerRef}
                                                              {...nestedDragProvided.draggableProps}
                                                              {...nestedDragProvided.dragHandleProps}
                                                              className={`${style.nestedQuestionCard} ${
                                                                nestedSnapshot.isDragging ? style.dragging : ''
                                                              }`}
                                                            >
                                                              <div
                                                                key={items.question_id}
                                                                className={`${style.questionContent} ${
                                                                  collapse[items.question_draft_id]
                                                                    ? style.questionContentCollapsed
                                                                    : style.questionContentExpanded
                                                                }`}
                                                              >
                                                                <>
                                                                  <div className={style.cardHeader}>
                                                                    <div className={style.cardLeft}>
                                                                      <div className={style.serialNoWrap}>
                                                                        <span>
                                                                          {getSerialNumber(
                                                                            items.question_id,
                                                                            items.id,
                                                                            i,
                                                                            nestedIndex
                                                                          )}
                                                                        </span>
                                                                      </div>

                                                                      {!isView ? (
                                                                        <svg
                                                                          width="20"
                                                                          height="20"
                                                                          viewBox="0 0 20 20"
                                                                          fill="none"
                                                                          xmlns="http://www.w3.org/2000/svg"
                                                                        >
                                                                          <path
                                                                            d="M8.4375 4.6875C8.4375 4.93473 8.36419 5.1764 8.22684 5.38196C8.08949 5.58752 7.89426 5.74774 7.66585 5.84235C7.43745 5.93696 7.18611 5.96171 6.94364 5.91348C6.70116 5.86525 6.47843 5.7462 6.30362 5.57138C6.1288 5.39657 6.00975 5.17384 5.96152 4.93136C5.91329 4.68889 5.93804 4.43755 6.03265 4.20915C6.12726 3.98074 6.28748 3.78552 6.49304 3.64816C6.6986 3.51081 6.94027 3.4375 7.1875 3.4375C7.51902 3.4375 7.83696 3.5692 8.07138 3.80362C8.3058 4.03804 8.4375 4.35598 8.4375 4.6875ZM12.8125 5.9375C13.0597 5.9375 13.3014 5.86419 13.507 5.72684C13.7125 5.58949 13.8727 5.39426 13.9674 5.16585C14.062 4.93745 14.0867 4.68611 14.0385 4.44364C13.9903 4.20116 13.8712 3.97843 13.6964 3.80362C13.5216 3.6288 13.2988 3.50975 13.0564 3.46152C12.8139 3.41329 12.5626 3.43804 12.3341 3.53265C12.1057 3.62726 11.9105 3.78748 11.7732 3.99304C11.6358 4.1986 11.5625 4.44027 11.5625 4.6875C11.5625 5.01902 11.6942 5.33696 11.9286 5.57138C12.163 5.8058 12.481 5.9375 12.8125 5.9375ZM7.1875 8.75C6.94027 8.75 6.6986 8.82331 6.49304 8.96066C6.28748 9.09802 6.12726 9.29324 6.03265 9.52165C5.93804 9.75005 5.91329 10.0014 5.96152 10.2439C6.00975 10.4863 6.1288 10.7091 6.30362 10.8839C6.47843 11.0587 6.70116 11.1778 6.94364 11.226C7.18611 11.2742 7.43745 11.2495 7.66585 11.1549C7.89426 11.0602 8.08949 10.9 8.22684 10.6945C8.36419 10.4889 8.4375 10.2472 8.4375 10C8.4375 9.66848 8.3058 9.35054 8.07138 9.11612C7.83696 8.8817 7.51902 8.75 7.1875 8.75ZM12.8125 8.75C12.5653 8.75 12.3236 8.82331 12.118 8.96066C11.9125 9.09802 11.7523 9.29324 11.6577 9.52165C11.563 9.75005 11.5383 10.0014 11.5865 10.2439C11.6348 10.4863 11.7538 10.7091 11.9286 10.8839C12.1034 11.0587 12.3262 11.1778 12.5686 11.226C12.8111 11.2742 13.0624 11.2495 13.2909 11.1549C13.5193 11.0602 13.7145 10.9 13.8518 10.6945C13.9892 10.4889 14.0625 10.2472 14.0625 10C14.0625 9.66848 13.9308 9.35054 13.6964 9.11612C13.462 8.8817 13.144 8.75 12.8125 8.75ZM7.1875 14.0625C6.94027 14.0625 6.6986 14.1358 6.49304 14.2732C6.28748 14.4105 6.12726 14.6057 6.03265 14.8341C5.93804 15.0626 5.91329 15.3139 5.96152 15.5564C6.00975 15.7988 6.1288 16.0216 6.30362 16.1964C6.47843 16.3712 6.70116 16.4903 6.94364 16.5385C7.18611 16.5867 7.43745 16.562 7.66585 16.4674C7.89426 16.3727 8.08949 16.2125 8.22684 16.007C8.36419 15.8014 8.4375 15.5597 8.4375 15.3125C8.4375 14.981 8.3058 14.663 8.07138 14.4286C7.83696 14.1942 7.51902 14.0625 7.1875 14.0625ZM12.8125 14.0625C12.5653 14.0625 12.3236 14.1358 12.118 14.2732C11.9125 14.4105 11.7523 14.6057 11.6577 14.8341C11.563 15.0626 11.5383 15.3139 11.5865 15.5564C11.6348 15.7988 11.7538 16.0216 11.9286 16.1964C12.1034 16.3712 12.3262 16.4903 12.5686 16.5385C12.8111 16.5867 13.0624 16.562 13.2909 16.4674C13.5193 16.3727 13.7145 16.2125 13.8518 16.007C13.9892 15.8014 14.0625 15.5597 14.0625 15.3125C14.0625 14.981 13.9308 14.663 13.6964 14.4286C13.462 14.1942 13.144 14.0625 12.8125 14.0625Z"
                                                                            fill="#272727"
                                                                          />
                                                                        </svg>
                                                                      ) : (
                                                                        ''
                                                                      )}

                                                                      <div className={style.changeCheckBox}>
                                                                        <label
                                                                          className="custom-checkbox"
                                                                          aria-label="checkbox"
                                                                        >
                                                                          <input
                                                                            type="checkbox"
                                                                            checked={removeId?.includes(
                                                                              items.question_id
                                                                            )}
                                                                            onChange={(e) => {
                                                                              RemoveIds(items, e.target.checked);
                                                                            }}
                                                                          />
                                                                          <span className="checkmark"></span>
                                                                        </label>
                                                                      </div>

                                                                      <div
                                                                        className={style.questionId}
                                                                        onClick={() => {
                                                                          setBankId(items.question_bank);
                                                                          handleOpenModal(items.question_id);
                                                                        }}
                                                                      >
                                                                        <span className={style.questionNumber}>
                                                                          ID:
                                                                        </span>
                                                                        {items.question_id}
                                                                      </div>
                                                                    </div>
                                                                    <div className={style.cardRight}>
                                                                      <div className={style.staticListScore}>
                                                                        <input
                                                                          title={
                                                                            items.correct_answer_marks === null
                                                                              ? (body.groups[groupsButton].sections[
                                                                                  sectionButton
                                                                                ].correct_answer_marks ??
                                                                                testDetails?.correct_answer_marks)
                                                                              : items.correct_answer_marks
                                                                          }
                                                                          onKeyDown={(e) => {
                                                                            if (
                                                                              e.key === 'ArrowUp' ||
                                                                              e.key === 'ArrowDown'
                                                                            ) {
                                                                              e.preventDefault();
                                                                            }
                                                                          }}
                                                                          onWheel={(e) => e.target.blur()}
                                                                          autoComplete="off"
                                                                          type="number"
                                                                          style={{ border: 'none' }}
                                                                          value={
                                                                            items.correct_answer_marks === null
                                                                              ? (body.groups[groupsButton].sections[
                                                                                  sectionButton
                                                                                ].correct_answer_marks ??
                                                                                testDetails?.correct_answer_marks)
                                                                              : items.correct_answer_marks
                                                                          }
                                                                          disabled
                                                                          className={style.scoreInput}
                                                                        />
                                                                        <input
                                                                          title={
                                                                            items.incorrect_answer_marks === null
                                                                              ? (body.groups[groupsButton].sections[
                                                                                  sectionButton
                                                                                ].incorrect_answer_marks ??
                                                                                testDetails?.incorrect_answer_marks)
                                                                              : items.incorrect_answer_marks
                                                                          }
                                                                          onKeyDown={(e) => {
                                                                            if (
                                                                              e.key === 'ArrowUp' ||
                                                                              e.key === 'ArrowDown'
                                                                            ) {
                                                                              e.preventDefault();
                                                                            }
                                                                          }}
                                                                          style={{ border: 'none' }}
                                                                          onWheel={(e) => e.target.blur()}
                                                                          autoComplete="off"
                                                                          type="number"
                                                                          value={
                                                                            items.incorrect_answer_marks === null
                                                                              ? (body.groups[groupsButton].sections[
                                                                                  sectionButton
                                                                                ].incorrect_answer_marks ??
                                                                                testDetails?.incorrect_answer_marks)
                                                                              : items.incorrect_answer_marks
                                                                          }
                                                                          disabled
                                                                          className={style.scoreInput}
                                                                        />
                                                                      </div>

                                                                      {!isView &&
                                                                        (onAdd ||
                                                                          (isEdit && testDetails?.delete_question)) && (
                                                                          <div
                                                                            className={style.quasiReplaceIcon}
                                                                            onClick={() => GetReplace(items)}
                                                                          >
                                                                            <img
                                                                              src={staticReplace}
                                                                              className={style.iconInfo}
                                                                              style={{ margin: '0 8px' }}
                                                                              alt="edit"
                                                                            />
                                                                          </div>
                                                                        )}
                                                                      {!isView &&
                                                                        (onAdd ||
                                                                          (isEdit && testDetails?.delete_question)) && (
                                                                          <div
                                                                            className={style.quasiDeleteIcon}
                                                                            onClick={() => GetDelete(items)}
                                                                          >
                                                                            <img
                                                                              src={staticDelete}
                                                                              className={style.iconInfo}
                                                                              style={{ margin: '0 8px' }}
                                                                              alt="delete"
                                                                            />
                                                                          </div>
                                                                        )}
                                                                    </div>
                                                                  </div>
                                                                  <div className={style.cardBody}>
                                                                    <div className={style.tags}>
                                                                      <span className={style.primaryTag}>
                                                                        {items?.primary_tag?.slug}
                                                                      </span>
                                                                      {items?.free_tags?.slice(0, 2).map((tag, i) => (
                                                                        <span key={i} className={style.freeTag}>
                                                                          {tag.name}
                                                                        </span>
                                                                      ))}
                                                                      {items?.free_tags?.length > 2 && (
                                                                        <span className={style.moreTags}>
                                                                          +{items?.free_tags?.length - 2}
                                                                        </span>
                                                                      )}
                                                                    </div>
                                                                    <div className={style.questionIdentifier}>
                                                                      <span className={style.shortIdentifier}>
                                                                        {items?.question_short_identifier}
                                                                      </span>
                                                                    </div>
                                                                    {/* FreeTags Section */}
                                                                    <div
                                                                      className={`${style.general_tag} ${style.quasiGeneralTags}`}
                                                                      style={{
                                                                        display: 'flex',
                                                                        justifyContent: 'flex-start',
                                                                      }}
                                                                    >
                                                                      {items?.free_tags?.map((item, i) => (
                                                                        <button
                                                                          key={i}
                                                                          className={`${style.general_button} ${style.generalButtonWrap}`}
                                                                        >
                                                                          {item.name}
                                                                        </button>
                                                                      ))}
                                                                    </div>
                                                                    <div className={style.Quasimetadata}>
                                                                      <div
                                                                        className={`${style.metaRow} ${style.QuasimetaRowAuthor}`}
                                                                      >
                                                                        <span className={style.metaLabel}>Author:</span>
                                                                        <span
                                                                          className={style.metaValue}
                                                                          style={{
                                                                            whiteSpace: 'normal',
                                                                            overflowWrap: 'break-word',
                                                                            maxWidth: '100%',
                                                                          }}
                                                                        >
                                                                          {items.created_by}
                                                                        </span>
                                                                      </div>
                                                                      <div
                                                                        className={`${style.metaRow} ${style.QuasimetaRowYear}`}
                                                                      >
                                                                        <span className={style.metaLabel}>
                                                                          Academic Year:
                                                                        </span>
                                                                        <span className={style.metaValue}>
                                                                          {items.academic_year}
                                                                        </span>
                                                                      </div>
                                                                      <div
                                                                        className={`${style.metaRow} ${style.QuasimetaRowCreatedOn}`}
                                                                      >
                                                                        <span className={style.metaLabel}>
                                                                          Created On:
                                                                        </span>
                                                                        <span className={style.metaValue}>
                                                                          {moment(items.created_at).format(
                                                                            'Do MMM YYYY'
                                                                          )}
                                                                        </span>
                                                                      </div>
                                                                      <div
                                                                        className={`${style.metaRow} ${style.QuasimetaRowType}`}
                                                                      >
                                                                        <span className={style.metaLabel}>Type:</span>
                                                                        <span className={style.metaValue}>
                                                                          {items.type}
                                                                        </span>
                                                                      </div>
                                                                      <div
                                                                        className={`${style.metaRow} ${style.QuasimetaRowLOD}`}
                                                                      >
                                                                        <span className={style.metaLabel}>LOD:</span>
                                                                        <span className={style.metaValue}>
                                                                          {items.difficulty}
                                                                        </span>
                                                                      </div>
                                                                      <div
                                                                        className={`${style.metaRow} ${style.QuasimetaRowPvalue}`}
                                                                      >
                                                                        <span className={style.metaLabel}>
                                                                          P-value:
                                                                        </span>
                                                                        <span className={style.metaValue}>
                                                                          {items?.pvalue ?? '-'}
                                                                        </span>
                                                                      </div>
                                                                      <div
                                                                        className={`${style.metaRow} ${style.QuasimetaRowTestAttempt}`}
                                                                      >
                                                                        <span className={style.metaLabel}>
                                                                          Test Attempts:
                                                                        </span>
                                                                        <span className={style.metaValue}>
                                                                          {items?.test_attempts ?? '-'}
                                                                        </span>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </>
                                                              </div>
                                                            </div>
                                                          )}
                                                        </Draggable>
                                                      </div>
                                                    ))}
                                                    {nestedProvided.placeholder}
                                                  </div>
                                                )}
                                              </Droppable>
                                            ) : (
                                              items.questions.map((items, singleIndex) => (
                                                <div
                                                  key={items.question_id}
                                                  className={`${style.questionContent} ${
                                                    collapse[items.question_draft_id]
                                                      ? style.questionContentCollapsed
                                                      : style.questionContentExpanded
                                                  }`}
                                                >
                                                  <>
                                                    <div className={style.cardHeader}>
                                                      <div className={style.cardLeft}>
                                                        <div className={style.serialNoWrap}>
                                                          <span>
                                                            {getSerialNumber(
                                                              items.question_id,
                                                              items.id,
                                                              i,
                                                              singleIndex
                                                            )}
                                                          </span>
                                                        </div>
                                                        {!isView ? (
                                                          <svg
                                                            width="20"
                                                            height="20"
                                                            viewBox="0 0 20 20"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                          >
                                                            <path
                                                              d="M8.4375 4.6875C8.4375 4.93473 8.36419 5.1764 8.22684 5.38196C8.08949 5.58752 7.89426 5.74774 7.66585 5.84235C7.43745 5.93696 7.18611 5.96171 6.94364 5.91348C6.70116 5.86525 6.47843 5.7462 6.30362 5.57138C6.1288 5.39657 6.00975 5.17384 5.96152 4.93136C5.91329 4.68889 5.93804 4.43755 6.03265 4.20915C6.12726 3.98074 6.28748 3.78552 6.49304 3.64816C6.6986 3.51081 6.94027 3.4375 7.1875 3.4375C7.51902 3.4375 7.83696 3.5692 8.07138 3.80362C8.3058 4.03804 8.4375 4.35598 8.4375 4.6875ZM12.8125 5.9375C13.0597 5.9375 13.3014 5.86419 13.507 5.72684C13.7125 5.58949 13.8727 5.39426 13.9674 5.16585C14.062 4.93745 14.0867 4.68611 14.0385 4.44364C13.9903 4.20116 13.8712 3.97843 13.6964 3.80362C13.5216 3.6288 13.2988 3.50975 13.0564 3.46152C12.8139 3.41329 12.5626 3.43804 12.3341 3.53265C12.1057 3.62726 11.9105 3.78748 11.7732 3.99304C11.6358 4.1986 11.5625 4.44027 11.5625 4.6875C11.5625 5.01902 11.6942 5.33696 11.9286 5.57138C12.163 5.8058 12.481 5.9375 12.8125 5.9375ZM7.1875 8.75C6.94027 8.75 6.6986 8.82331 6.49304 8.96066C6.28748 9.09802 6.12726 9.29324 6.03265 9.52165C5.93804 9.75005 5.91329 10.0014 5.96152 10.2439C6.00975 10.4863 6.1288 10.7091 6.30362 10.8839C6.47843 11.0587 6.70116 11.1778 6.94364 11.226C7.18611 11.2742 7.43745 11.2495 7.66585 11.1549C7.89426 11.0602 8.08949 10.9 8.22684 10.6945C8.36419 10.4889 8.4375 10.2472 8.4375 10C8.4375 9.66848 8.3058 9.35054 8.07138 9.11612C7.83696 8.8817 7.51902 8.75 7.1875 8.75ZM12.8125 8.75C12.5653 8.75 12.3236 8.82331 12.118 8.96066C11.9125 9.09802 11.7523 9.29324 11.6577 9.52165C11.563 9.75005 11.5383 10.0014 11.5865 10.2439C11.6348 10.4863 11.7538 10.7091 11.9286 10.8839C12.1034 11.0587 12.3262 11.1778 12.5686 11.226C12.8111 11.2742 13.0624 11.2495 13.2909 11.1549C13.5193 11.0602 13.7145 10.9 13.8518 10.6945C13.9892 10.4889 14.0625 10.2472 14.0625 10C14.0625 9.66848 13.9308 9.35054 13.6964 9.11612C13.462 8.8817 13.144 8.75 12.8125 8.75ZM7.1875 14.0625C6.94027 14.0625 6.6986 14.1358 6.49304 14.2732C6.28748 14.4105 6.12726 14.6057 6.03265 14.8341C5.93804 15.0626 5.91329 15.3139 5.96152 15.5564C6.00975 15.7988 6.1288 16.0216 6.30362 16.1964C6.47843 16.3712 6.70116 16.4903 6.94364 16.5385C7.18611 16.5867 7.43745 16.562 7.66585 16.4674C7.89426 16.3727 8.08949 16.2125 8.22684 16.007C8.36419 15.8014 8.4375 15.5597 8.4375 15.3125C8.4375 14.981 8.3058 14.663 8.07138 14.4286C7.83696 14.1942 7.51902 14.0625 7.1875 14.0625ZM12.8125 14.0625C12.5653 14.0625 12.3236 14.1358 12.118 14.2732C11.9125 14.4105 11.7523 14.6057 11.6577 14.8341C11.563 15.0626 11.5383 15.3139 11.5865 15.5564C11.6348 15.7988 11.7538 16.0216 11.9286 16.1964C12.1034 16.3712 12.3262 16.4903 12.5686 16.5385C12.8111 16.5867 13.0624 16.562 13.2909 16.4674C13.5193 16.3727 13.7145 16.2125 13.8518 16.007C13.9892 15.8014 14.0625 15.5597 14.0625 15.3125C14.0625 14.981 13.9308 14.663 13.6964 14.4286C13.462 14.1942 13.144 14.0625 12.8125 14.0625Z"
                                                              fill="#272727"
                                                            />
                                                          </svg>
                                                        ) : (
                                                          ''
                                                        )}
                                                        <div className={style.changeCheckBox}>
                                                          <label className="custom-checkbox" aria-label="checkbox">
                                                            <input
                                                              type="checkbox"
                                                              checked={removeId?.includes(items.question_id)}
                                                              onChange={(e) => {
                                                                RemoveIds(items, e.target.checked);
                                                              }}
                                                            />
                                                            <span className="checkmark"></span>
                                                          </label>
                                                        </div>

                                                        <div
                                                          className={style.questionId}
                                                          onClick={() => {
                                                            setBankId(items.question_bank);
                                                            handleOpenModal(items.question_id);
                                                          }}
                                                        >
                                                          <span className={style.questionNumber}>ID:</span>
                                                          {items.question_id}
                                                        </div>
                                                      </div>
                                                      <div className={style.cardRight}>
                                                        <div className={style.staticListScore}>
                                                          <input
                                                            title={
                                                              items.correct_answer_marks === null
                                                                ? (body.groups[groupsButton].sections[sectionButton]
                                                                    .correct_answer_marks ??
                                                                  testDetails?.correct_answer_marks)
                                                                : items.correct_answer_marks
                                                            }
                                                            onKeyDown={(e) => {
                                                              if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                                e.preventDefault();
                                                              }
                                                            }}
                                                            onWheel={(e) => e.target.blur()}
                                                            autoComplete="off"
                                                            type="number"
                                                            style={{ border: 'none' }}
                                                            value={
                                                              items.correct_answer_marks === null
                                                                ? (body.groups[groupsButton].sections[sectionButton]
                                                                    .correct_answer_marks ??
                                                                  testDetails?.correct_answer_marks)
                                                                : items.correct_answer_marks
                                                            }
                                                            disabled
                                                            className={style.scoreInput}
                                                          />
                                                          <input
                                                            title={
                                                              items.incorrect_answer_marks === null
                                                                ? (body.groups[groupsButton].sections[sectionButton]
                                                                    .incorrect_answer_marks ??
                                                                  testDetails?.incorrect_answer_marks)
                                                                : items.incorrect_answer_marks
                                                            }
                                                            onKeyDown={(e) => {
                                                              if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                                e.preventDefault();
                                                              }
                                                            }}
                                                            style={{ border: 'none' }}
                                                            onWheel={(e) => e.target.blur()}
                                                            autoComplete="off"
                                                            type="number"
                                                            value={
                                                              items.incorrect_answer_marks === null
                                                                ? (body.groups[groupsButton].sections[sectionButton]
                                                                    .incorrect_answer_marks ??
                                                                  testDetails?.incorrect_answer_marks)
                                                                : items.incorrect_answer_marks
                                                            }
                                                            disabled
                                                            className={style.scoreInput}
                                                          />
                                                        </div>

                                                        {!isView &&
                                                          (onAdd || (isEdit && testDetails?.delete_question)) && (
                                                            <div
                                                              className={style.quasiReplaceIcon}
                                                              onClick={() => GetReplace(items)}
                                                            >
                                                              <img
                                                                src={staticReplace}
                                                                className={style.iconInfo}
                                                                style={{ margin: '0 8px' }}
                                                                alt="edit"
                                                              />
                                                            </div>
                                                          )}
                                                        {!isView &&
                                                          (onAdd || (isEdit && testDetails?.delete_question)) && (
                                                            <div
                                                              className={style.quasiDeleteIcon}
                                                              onClick={() => GetDelete(items)}
                                                            >
                                                              <img
                                                                src={staticDelete}
                                                                className={style.iconInfo}
                                                                style={{ margin: '0 8px' }}
                                                                alt="delete"
                                                              />
                                                            </div>
                                                          )}
                                                      </div>
                                                    </div>
                                                    <div className={style.cardBody}>
                                                      <div className={style.tags}>
                                                        <span className={style.primaryTag}>
                                                          {items?.primary_tag?.slug}
                                                        </span>
                                                        {items?.free_tags?.slice(0, 2).map((tag, i) => (
                                                          <span key={i} className={style.freeTag}>
                                                            {tag.name}
                                                          </span>
                                                        ))}
                                                        {items?.free_tags?.length > 2 && (
                                                          <span className={style.moreTags}>
                                                            +{items?.free_tags?.length - 2}
                                                          </span>
                                                        )}
                                                      </div>
                                                      <div className={style.questionIdentifier}>
                                                        <span className={style.shortIdentifier}>
                                                          {items?.question_short_identifier}
                                                        </span>
                                                      </div>
                                                      {/* FreeTags Section */}
                                                      <div
                                                        className={`${style.general_tag} ${style.quasiGeneralTags}`}
                                                        style={{ display: 'flex', justifyContent: 'flex-start' }}
                                                      >
                                                        {items?.free_tags?.map((item, i) => (
                                                          <button
                                                            key={i}
                                                            className={`${style.general_button} ${style.generalButtonWrap}`}
                                                          >
                                                            {item.name}
                                                          </button>
                                                        ))}
                                                      </div>
                                                      <div className={style.Quasimetadata}>
                                                        <div className={`${style.metaRow} ${style.QuasimetaRowAuthor}`}>
                                                          <span className={style.metaLabel}>Author:</span>
                                                          <span
                                                            className={style.metaValue}
                                                            style={{
                                                              whiteSpace: 'normal',
                                                              overflowWrap: 'break-word',
                                                              maxWidth: '100%',
                                                            }}
                                                          >
                                                            {items.created_by}
                                                          </span>
                                                        </div>
                                                        <div className={`${style.metaRow} ${style.QuasimetaRowYear}`}>
                                                          <span className={style.metaLabel}>Academic Year:</span>
                                                          <span className={style.metaValue}>{items.academic_year}</span>
                                                        </div>
                                                        <div
                                                          className={`${style.metaRow} ${style.QuasimetaRowCreatedOn}`}
                                                        >
                                                          <span className={style.metaLabel}>Created On:</span>
                                                          <span className={style.metaValue}>
                                                            {moment(items.created_at).format('Do MMM YYYY')}
                                                          </span>
                                                        </div>
                                                        <div className={`${style.metaRow} ${style.QuasimetaRowType}`}>
                                                          <span className={style.metaLabel}>Type:</span>
                                                          <span className={style.metaValue}>{items.type}</span>
                                                        </div>
                                                        <div className={`${style.metaRow} ${style.QuasimetaRowLOD}`}>
                                                          <span className={style.metaLabel}>LOD:</span>
                                                          <span className={style.metaValue}>{items.difficulty}</span>
                                                        </div>
                                                        <div className={`${style.metaRow} ${style.QuasimetaRowPvalue}`}>
                                                          <span className={style.metaLabel}>P-value:</span>
                                                          <span className={style.metaValue}>
                                                            {items?.pvalue ?? '-'}
                                                          </span>
                                                        </div>
                                                        <div
                                                          className={`${style.metaRow} ${style.QuasimetaRowTestAttempt}`}
                                                        >
                                                          <span className={style.metaLabel}>Test Attempts:</span>
                                                          <span className={style.metaValue}>
                                                            {items?.test_attempts ?? '-'}
                                                          </span>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </>
                                                </div>
                                              ))
                                            )}
                                          </div>
                                        )}
                                      </Draggable>
                                    ))}
                                    {provided.placeholder}
                                  </div>
                                )}
                              </Droppable>

                              <footer className={style.sectionFooter}>
                                <div className={style.footer_content}>
                                  <span style={{ fontWeight: '500' }}>Selected Questions</span>
                                  <span>
                                    {removeId.length}{' '}
                                    <b style={{ color: 'lightgray' }}>/{sectionItem.no_of_questions}</b>
                                  </span>
                                </div>

                                <div className={`${style.footer_content_mid} ${style.footer_content_start}`}>
                                  {/* {Array.from(
                                    new Set(
                                      sectionItem.questionList?.flatMap(
                                        (q) => q?.questions?.map((item) => item?.question_id) || []
                                      )
                                    )
                                  ).map((questionId, i) => (
                                    <span key={i} className={style.closeIds}>
                                      {questionId}
                                    </span>
                                  ))} */}
                                  {removeId.map((questionId, i) => (
                                    <span key={i} className={style.closeIds}>
                                      {questionId}
                                    </span>
                                  ))}
                                </div>

                                <div className={style.footer_content_right}>
                                  {!isView && (
                                    <>
                                      {(onAdd || (isEdit && testDetails?.delete_question)) && (
                                        <span
                                          style={{
                                            textDecoration: 'underline',
                                            fontWeight: '500',
                                            cursor: 'pointer',
                                            position: 'relative',
                                            left: '20px',
                                          }}
                                          onClick={() => DeleteIdFromList()}
                                        >
                                          Delete Selected
                                        </span>
                                      )}
                                      <div className={style.drop_score} onClick={() => OpenMarkingLogic()}>
                                        Set Marking Logic &nbsp;
                                        <svg
                                          width="26"
                                          style={{
                                            rotate: markingLogicStatus ? '' : '180deg',
                                          }}
                                          height="24"
                                          viewBox="0 0 26 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <g clipPath="url(#clip0_1445_47115)">
                                            <path
                                              d="M5.01822 16.0469L11.7264 9.52687C12.5186 8.75687 13.815 8.75687 14.6072 9.52687L21.3154 16.0469"
                                              stroke="white"
                                              strokeWidth="1.5"
                                              strokeMiterlimit="10"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            />
                                          </g>
                                          <defs>
                                            <clipPath id="clip0_1445_47115">
                                              <rect x="0.820312" width="24.6927" height="24" rx="12" fill="white" />
                                            </clipPath>
                                          </defs>
                                        </svg>
                                      </div>
                                    </>
                                  )}
                                  <div
                                    className={style.logic}
                                    style={{
                                      display: markingLogicStatus ? 'block' : 'none',
                                    }}
                                  >
                                    <div className={style.logics_input}>
                                      <div className={style.new} onClick={() => AddNewScore()}>
                                        <svg
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                                            stroke="#00ABFB"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                          <path
                                            d="M7.5 12H16.5"
                                            stroke="#00ABFB"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                          <path
                                            d="M12 16.5V7.5"
                                            stroke="#00ABFB"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                        </svg>
                                        &nbsp; New Scoring Logic
                                      </div>
                                      <div className={style.scoring}>
                                        {markingLogic?.map((items, i) => (
                                          <div key={i} className={style.inputs} style={{ gap: '10px' }}>
                                            <input
                                              type="radio"
                                              key={items}
                                              id={i}
                                              name="logic"
                                              onClick={() => SelectedMarkingLogic(items)}
                                            />
                                            <input
                                              onChange={(e) => handleCorrectAnswerChange(e, i)}
                                              type="number"
                                              className={style.inputsNumber}
                                              style={{
                                                display: 'inline',
                                                width: '20%',
                                                border: 'none',
                                                background: 'transparent',
                                              }}
                                              value={items?.correct_answer_marks}
                                            />
                                            <input
                                              onChange={(e) => handleInCorrectAnswerChange(e, i)}
                                              type="number"
                                              style={{
                                                display: 'inline',
                                                width: '20%',
                                                border: 'none',
                                                background: 'transparent',
                                              }}
                                              value={items?.incorrect_answer_marks}
                                            />
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </footer>
                            </div>
                          )}
                          {!isView && (
                            <div style={{ marginTop: '2rem' }} className={style.performBT}>
                              <button
                                onClick={() => dispatch(changeAdd_test_screen(0))}
                                className={` ${style.btOne} ${style.common}`}
                              >
                                Back
                              </button>
                              <button
                                className={` ${style.btTwo} ${style.common}`}
                                onClick={() => {
                                  const showReferenceSheetToggle = [3, 8, 9].includes(
                                    Number(getBasicSettingData?.rendering_template ?? testDetails?.rendering_template)
                                  );

                                  if (showReferenceSheetToggle) {
                                    for (let gIdx = 0; gIdx < body.groups.length; gIdx++) {
                                      const group = body.groups[gIdx];
                                      if (group.enable_reference_sheet) {
                                        const refContent = decodeBase64(group.reference_sheet || '');
                                        const hasImage = /<(img|svg)\b/i.test(refContent);
                                        const stripped = refContent
                                          .replace(/<[^>]*>/g, '')
                                          .replace(/&nbsp;/g, ' ')
                                          .trim();
                                        if (!hasImage && stripped.length === 0) {
                                          toast?.add(
                                            `Reference Sheet content is mandatory for Group ${gIdx + 1} when enabled.`,
                                            'error'
                                          );
                                          return;
                                        }
                                      }
                                    }
                                  }

                                  // Deep clone the body to avoid mutating state
                                  const bodyClone = structuredClone(body);
                                  // Loop through all groups and sections to remove questionList
                                  bodyClone.groups.forEach((group) => {
                                    group.sections.forEach((section) => {
                                      delete section.questionList;
                                    });
                                  });

                                  if (isEdit) {
                                    dispatch(
                                      Edit_Section_Test(bodyClone, testDetails?.id ?? testCreationId, testType, toast)
                                    );
                                  } else if (onAdd && structuredClone(sectionBody).hasOwnProperty('groups')) {
                                    dispatch(
                                      Edit_Section_Test(bodyClone, testDetails?.id ?? testCreationId, testType, toast)
                                    );
                                  } else {
                                    dispatch(
                                      Add_Section_Test(bodyClone, testDetails?.id ?? testCreationId, testType, toast)
                                    );
                                  }

                                  // Optional: refetch test data
                                  // getData(testDetails?.id ?? testCreationId);
                                }}
                              >
                                Save And Continue
                              </button>
                            </div>
                          )}
                        </div>
                      ))}
                  </div>
                ))}
            </DragDropContext>
            {modal ? (
              <BrowsingQuestion
                SetSelectIds={SetSelectIds}
                selectIds={selectIds}
                selectedIds={body.groups[groupsButton].sections[sectionButton]?.questions}
                setModal={setModal}
                totalQuestion={body.groups[groupsButton].sections[sectionButton].no_of_questions}
                AddToTestPaper={AddToTestPaper}
                testType={testType}
                sectionName={body.groups[groupsButton].group_name}
                roundNo={''}
                setName={body.groups[groupsButton].sections[sectionButton].section_name}
                isPublished={isPublished}
              />
            ) : (
              ''
            )}
            <PreviewModal
              onEdit={handleEdit}
              questionAccess={questionAccess}
              selectedQuestion={selectedQuestion}
              isOpen={isPreviewopen}
              onClose={handleCloseModal}
              setIsDuplicateModalOpen={setIsModalOpen}
              setModalData={setModalData}
              modalData={modalData}
              setIsDuplicatePreview={setIsDuplicatePreview}
              iframeSrc="/question-content-url"
            />
            <QuestionListModal
              isOpen={isModalOpen}
              onClose={closeModal}
              onConfirm={onConfirmDuplicate}
              data={modalData} // Pass modalData to the modal
              isDuplicatePreview={isDuplicatePreview}
            />
            <LockModal
              modalData={modalModalData}
              forwardButton={() => navigate('/edit-question', { state: questionItem })}
              modalMedium={modalMedium}
              closeModalMedium={closeModalMedium}
            />
          </div>
        </div>
      )}
      {testType === 1 && <QuasiSections getData={getData} isEdit={isEdit} onAdd={onAdd} isView={isView} />}
      {testType === 2 && <LoftSections getData={getData} isEdit={isEdit} onAdd={onAdd} isView={isView} />}
    </>
  );
};

Sections.propTypes = {
  getData: PropTypes.any,
  isEdit: PropTypes.any,
  isView: PropTypes.any,
  onAdd: PropTypes.any,
  isPublished: PropTypes.any,
};

export default Sections;
